import { Injectable, NgZone } from '@angular/core';
import { RemoteService } from './remote.service';
import { AppConfig } from './helper/app.config';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { Logger, LogLevel } from './helper/app-error-logger';
import { AppEinstellungen, PushMessageHeader, PushMessageType, StatusUpdatePushMessage, GeoPositionenPushMessage, LoginPushMessage, AuftragUpdatePushMessage, GeraetZuruecksetzenPushMessage, Ringtone, DownloadFile, GpsLocation, AuftragListItem, NfcEvent } from './model/model';
import { Network } from '@capacitor/network';
import { NativeAudio } from '@capacitor-community/native-audio';
import { PowerManagement } from '@awesome-cordova-plugins/power-management/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions';

import { Platform, ToastController } from '@ionic/angular';
import { MyApp } from './helper/app';

import { Textdatei, TextdateiTyp, GpsPosition, Adresse, SendResult, GpsPositionPush } from './model/swagger-model';
import { AppConsole } from './helper/app-console';
import { AppStorage } from './helper/app-storage';
import { FileHelper } from './helper/file-helper';
import { Utils } from './helper/utils';
import { UiHelper } from './helper/ui-helper';
import { AppFileLogger } from './helper/app-file-logger';
import { AppService } from './helper/app-services';
import { LaunchNavigatorService } from './plugins/launch-navigator.service';
import { LaunchNavigatorOptions } from './plugins/launch-navigator.types';
import { WebIntent } from '@awesome-cordova-plugins/web-intent/ngx';
import { NFC } from '@awesome-cordova-plugins/nfc/ngx';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Geolocation } from '@capacitor/geolocation';
import { environment } from 'src/environments/environment';
import { BackgroundGeolocation, BackgroundGeolocationConfig, BackgroundGeolocationEvents, BackgroundGeolocationLocationProvider } from '@awesome-cordova-plugins/background-geolocation/ngx';

import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from './plugins/push-plugin';
import { BackgroundMode } from './plugins/background-mode-plugin';
import { ApkUpdaterPlugin } from './plugins/apkupdater-plugin';
import { Directory, DownloadFileResult, Encoding, Filesystem } from '@capacitor/filesystem';
import { Constants } from './model/constants';

// Für CAPACITOR Background Geolocation. Derzeit noch deaktiviert.
// Das Capacitor-Plugin macht einen schlechteren Eindruck, da die Positionen nicht vom Plugin nativ protokolliert werden.
// import { registerPlugin } from "@capacitor/core";
// import { BackgroundGeolocationPlugin, CallbackError, Location, WatcherOptions } from "@capacitor-community/background-geolocation";
// const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>("BackgroundGeolocation");

declare var cordova: any;

const log = new Logger("SystemService", LogLevel.INFO);

type PendingWebSocketMessage = {
    resolve: (ok: boolean) => void;
    timeoutId: ReturnType<typeof setTimeout>;
};

@Injectable({
    providedIn: 'root'
})
export class SystemService {
    static instance: SystemService;

    private appConfigWirdGeladen = false;
    private appConfigGeladen = false;
    private appConfigGeladenEvent = new Subject<void>();

    // private postausgang: Postausgang = null;

    private deviceId = null;

    private webSocket: WebSocket = null;

    /** Laufende sendWebSocketMessage-Aufrufe (Promise wird erst nach echtem socket.send oder Abbruch / Timeout aufgelöst). */
    private webSocketSendSeq = 0;
    private webSocketSendPending = new Map<number, PendingWebSocketMessage>();

    istImVordergrund = new BehaviorSubject<boolean>(true);

    private lastMessageReceived = Date.now();
    private lastMessageSend = Date.now();
    private verfuegbareKlingeltoene: Ringtone[] = [];

    private sendenPostausgangLaeuft = false;

    auftraegeAktualisieren = new Subject<void>();
    stammdatenAktualisieren = new Subject<void>();
    einstellungenAktualisieren = new Subject<void>();
    fahrerAktualisieren = new Subject<void>();
    fahrzeugeAktualisieren = new Subject<void>();
    uvvAktualisieren = new Subject<void>();
    nachrichtenAktualisieren = new Subject<void>();
    tourenAktualisieren = new Subject<void>();
    changelogAktualisieren = new Subject<void>();
    texteAktualisieren = new Subject<void>();

    auftragUpdate = new Subject<AuftragUpdatePushMessage>();

    /**
     * Wird ausgelöst, wenn der Server das Zurücksetzen der App anfordert (Fernlöschung durch einen Sysadmin).
     * Die eigentliche Löschung übernimmt die AppComponent, da dort alle benötigten Services verfügbar sind.
     */
    geraetZuruecksetzenAngefordert = new Subject<void>();

    pushAvailable = new BehaviorSubject<boolean>(false);
    pushRegistrationId = new BehaviorSubject<string>('');
    pushRegistrationType = new BehaviorSubject<string>('');
    webSocketStatus = new BehaviorSubject<string>('');
    webSocketConnected = new BehaviorSubject<boolean>(false);
    webSocketNachrichtEmpfangen = new Subject<PushMessageHeader>();

    // currentPosition = new BehaviorSubject<GpsLocation>(null);

    pushNotificationEmpfangen = new Subject<PushNotificationSchema>();

    // Für die Aufzeichnung von GPS-Positionen
    // geoPositionen = new BehaviorSubject<GpsLocation[]>([]);

    // Datum (Ticks) an dem das letzte mal Geo-Positionen geschickt wurden
    geoPositionenGesendet = Date.now();

    /**
     * Zeitpunkt an dem der Background-Geolocation-Service das letzte mal neu gestartet wurde.
     */
    geolocationserviceLetzterRestart = Date.now();

    /**
     * Zeitpunkt, wann die letzte Geo-Position empfangen wurde.
     */
    letzteGeoLocationEmpfangen = Date.now();

    aktuellerKlingelton: string;
    positionenAufzeichnenAktiv = false;
    positionenSendenIntervalId: any;

    // File download
    filedownloadQueue: DownloadFile[] = null;
    downloadRunning = false;

    ringtonesInitialisiert = false;

    versionNumber = MyApp.version;

    einstellungenLetzteAktualisierung = 0;

    letzteGpsPosition: GpsPosition;
    letzteGpsPositionDate = 0;

    lastUpdateCheck = 0;
    pushRegistration: Token = null;
    pushRegistrationMandant: string;
    pushRegistrationGeraeteNummer: string;

    initialized = false;
    isVisible = new BehaviorSubject<boolean>(true);
    lastConfigStr = '';

    nfcSubscriptions: Subscription[] = [];
    nfcReceivers: NfcReceiver[] = [];
    nfcRecieverId = 0;
    nfcAktiv = false;

    gpsWatcherId: string = null;

    /**
     * Schutz gegen parallele Restart-Versuche.
     */
    private checkGeolocationStatusLaeuft = false;

    klingelnIntervalId: any = null;

    klingelnAktiv = false;

    postausgangOrdnerVorhanden = false;

    /**
     * Ein Set mit den Dateinamen, die gerade geschrieben werden.
     */
    writeFileSet = new Set<string>();

    /**
     * Liste mit fehlerhaften Dateien die nicht gesendet bzw. nicht gelesen werden können.
     * Diese Dateien sollen nicht gelöscht werden aber es soll auch nicht ständig versucht werden die Dateien zu senden.
     */
    errorFileSet = new Set<string>();

    lastPostausgangId = 0;

    constructor(
        private storage: Storage,
        private remoteService: RemoteService,
        private file: File,
        private nfc: NFC,
        private platform: Platform,
        private webIntent: WebIntent,
        private toastController: ToastController,
        private launchNavigator: LaunchNavigatorService,
        private ngZone: NgZone,
        private powerManagement: PowerManagement,
        // private backgroundMode: BackgroundMode,
        private backgroundGeolocation: BackgroundGeolocation,
        private fileTransfer: FileTransfer) {

        SystemService.instance = this;
        //// this.init();
    }

    async initialize() {
        log?.debug('initialize');

        try {
            Network.addListener('networkStatusChange', status => {
                const isConnected = status?.connected ?? false;

                // Nur reagieren, wenn sich der Status tatsächlich geändert hat
                if (MyApp.internetAvailable.getValue() !== isConnected) {
                    log?.debug('Network status changed: ' + JSON.stringify(status));

                    if (isConnected) {
                        MyApp.internetAvailable.next(true);
                    } else {
                        MyApp.internetAvailable.next(false);
                    }
                }
            });

            const status = await Network.getStatus();

            if (status?.connected) {
                MyApp.internetAvailable.next(true);
            }

            await this.ladeAppConfig();

            MyApp.internetAvailable.subscribe((connected) => this.connectivityChanged(connected));

            log?.debug('DEBUG: Wait platform ready');

            await MyApp.ready();

            log?.debug('DEBUG: Wait storage ready');

            await this.storage.create();

            log?.debug('DEBUG: platform + storage are ready');

            const updateFunction = () => {
                try {
                    this.update('updateFunction');
                } catch (err) {
                    log.error('update', err);
                }

                // Wenn die App im Vordergrund ist, dann alle 60 Sekunden aktualisieren.
                // Ansonsten alle 5 Minuten
                // Geht so nicht. Ansonsten bricht die WebSocket-Verbindung zusammen. Wir brauchen alle 120 Sekunden einen Ping
                // const time = this.istImVordergrund.getValue() ? 60 : 5 * 60;

                setTimeout(updateFunction, 60 * 1000);
            }

            setTimeout(updateFunction, 10 * 1000);


            // Hier überall kein await. Soll den App-Start nicht verzögern
            this.initFileLogger();
            this.initFileDownload();
            this.initAutostart();
            this.initPushNotifications();
            this.initBackgroundMode();
            this.initLocalNotifications();
            this.startBackgroundGeolocation();
            this.initNavigator();
            this.initNfc();
            this.collectSystemInfos();
            this.sendePostausgang();
            this.updateAnzahlPostausgangNachrichten();

            // Schreibe den Stats auch immer in ein App-Feld für den einfachen Zugriff
            this.istImVordergrund.subscribe((p) => MyApp.istImVordergrund = p);

            log?.debug('DEBUG 1');

            // Websocket wird eigentlich über 'onAppConfigChanged' initialisiert.
            // Wenn nicht, dann nach spätestens 10 Sekunden initialisieren
            setTimeout(() => {
                try {
                    if (!this.webSocket && MyApp.internetAvailable.getValue()) {
                        this.initWebSocket('setTimeout: kein webSocket');
                    }
                } catch (err) {
                    log.error('setTimeout: ' + Utils.getErrorMessage(err), err);
                }
            }, 10000);

            log?.debug('DEBUG 2');

            MyApp.current.configRefreshed.subscribe(() => {
                this.onAppConfigChanged();
            });

            log?.debug('DEBUG 3');

            setInterval(() => {
                this.collectSystemInfos();
            }, 5 * 60 * 1000);

            // AppConfig.changed.subscribe(p => this.onAppConfigChanged());

            this.einstellungenAktualisieren.subscribe(() => this.aktualisiereEinstellungen());

            document.addEventListener("deviceready", () => this.onDeviceReady(), false);
            document.addEventListener("pause", () => this.onPause(), false);
            document.addEventListener("resume", () => this.onResume(), false);

            if (!MyApp.isCordovaAvailable()) {
                // Nur zu Testzwecken
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        this.letzteGpsPosition = {
                            Latitude: position.coords.latitude,
                            Longitude: position.coords.longitude
                        };
                    });
                }
            }

            log?.debug('DEBUG 4');

            setTimeout(() => {
                this.starteDatenbereinigung();
            }, 30 * 1000);

        } catch (err) {
            log.error('initialize', err);
        }

        this.initialized = true;
    }

    /**
     * Startet die Datenbereinigung. Es werden alte Dateien gelöscht.
     */
    async starteDatenbereinigung() {
        // Lösche Bilder etc. die älter sind als 30 Tage
        log?.info('starteDatenbereinigung');

        await this.loescheAlteDateien(
            '',
            30,
            [
                'fuehrerscheinkontrolle-',
                'auftrag-',
                'Checkliste-',
            ]);
    }

    onResume() {
        log?.info('onResume');
        this.isVisible.next(true);
    }

    async onPause() {
        log?.info('onPause');
        this.isVisible.next(false);

        // try {
        //     log?.info('onPause: Move to Foreground');

        //     if (MyApp.isAndroid()) {
        //         await ForegroundService.moveToForeground();
        //     }
        // } catch (err) {
        //     log.error('onPause: ' + Utils.getErrorMessage(err), err);
        // }
    }

    onDeviceReady(): any {
        log?.info('onDeviceReady');

        const device = (window as any).device;

        log?.info('device' + JSON.stringify(device));
    }

    /**
     * Sammelt Informationen zum Gerät.
     * Diese Daten können mit an den ReCoMobil-Server geschickt werden
     */
    async collectSystemInfos() {
        log?.info('collectSystemInfos');

        try {
            await this.updatePermissionSystemAlertWindow();
        } catch (err) {
            log.error(Utils.getErrorMessage(err));
        }
    }

    /**
     * Berechtigung für "System Alerts".
     * Das ermöglicht der App, sich über anderen Apps anzuzeigen und damit auch in den Vordergrund zu holen.
     */
    async updatePermissionSystemAlertWindow() {
        log?.debug('updatePermissionSystemAlertWindow');

        return new Promise<boolean>((resolve) => {
            try {
                if (!MyApp.isCordovaAvailable() || typeof cordova === 'undefined' || !cordova?.plugins) {
                    AppConfig.current.permissionSystemAlertWindow = false;
                    resolve(false);
                    return;
                }

                const systemAlertWindowPermission = (cordova.plugins as any).systemAlertWindowPermission;

                if (systemAlertWindowPermission) {
                    systemAlertWindowPermission.hasPermission(
                        (e) => {
                            log?.info('systemAlertWindowPermission hasPermission result=' + JSON.stringify(e));
                            AppConfig.current.permissionSystemAlertWindow = !!e;
                            resolve(true);
                        },
                        (err) => {
                            log?.info('systemAlertWindowPermission hasPermission failed=' + JSON.stringify(err));
                            AppConfig.current.permissionSystemAlertWindow = false;
                            resolve(false);
                        });
                } else {
                    AppConfig.current.permissionSystemAlertWindow = false;
                    resolve(false);
                }
            } catch (err) {
                log.warn('updatePermissionSystemAlertWindow: ' + Utils.getErrorMessage(err));
                AppConfig.current.permissionSystemAlertWindow = false;
                resolve(false);
            }
        });
    }

    initNfc() {

        if (MyApp.isCordovaAvailable()) {
            try {
                log?.debug('initNfc');

                this.nfcSubscriptions.push(this.nfc.addNdefListener(async () => {
                    log?.debug('NFC listener added');
                    this.nfcAktiv = true;
                }, (err) => {
                    log.warn('NFC fehler', err);
                }).subscribe(async (event) => {
                    log?.info('NFC event', event);
                    this.verarbeiteNfcEvent(event);
                }));

                log?.debug('NFC addNdefFormatableListener');
                this.nfcSubscriptions.push(this.nfc.addNdefFormatableListener(async () => {
                    log?.debug('NFC addNdefFormatableListener added');
                }, (err) => {
                    log.warn('NFC addNdefFormatableListener fehler: ' + JSON.stringify(err), err);
                }).subscribe(async (event) => {
                    log?.debug('NFC ndef-formatable event: ' + JSON.stringify(event));
                    this.verarbeiteNfcEvent(event);
                }));
            } catch (err) {
                log.error('NFC exception: ' + err, err);
            }
        }
    }

    verarbeiteNfcEvent(event: any) {
        try {
            log?.debug('verarbeiteNfcEvent', event)

            let id: number[] = event.tag.id;

            if (MyApp.current.NfcFormat === "reverse") {
                id = id.reverse();
            }

            const seriennummer = this.nfc.bytesToHexString(id).trim().toUpperCase();
            const seriennummer2 = this.nfc.bytesToHexString(id.reverse()).trim().toUpperCase();

            let payload = '';
            const payloadList: string[] = [];

            log?.debug('NFC seriennummer: ' + seriennummer);

            if (MyApp.current.NfcPayloadVerwenden && event.tag.ndefMessage && event.tag.ndefMessage.length > 0) {
                const record = event.tag.ndefMessage[0];
                payload = this.nfc.bytesToString(record.payload).substring(3).trim().toUpperCase();

                log?.debug('NFC payload: ' + payload);

                for (const record of event.tag.ndefMessage) {
                    const payload = this.nfc.bytesToString(record.payload).substring(3);

                    if (payload.length > 5) {
                        payloadList.push(payload.trim().toUpperCase());
                    }
                }
            }

            this.ngZone.run(async () => {
                const nfcEvent: NfcEvent = {
                    id: id,
                    seriennummer: seriennummer,
                    seriennummer2: seriennummer2,
                    payload: payload,
                    payloadList: payloadList,
                    handled: false
                };

                for (const handler of this.nfcReceivers) {
                    if (typeof (handler.func) === 'function') {
                        handler.func(nfcEvent);

                        if (nfcEvent.handled) {
                            break;
                        }
                    }
                }
            });
        } catch (err) {
            log.error('verarbeiteNfcEvent: ' + err, err);
        }

        // const event: BarcodeEvent = {
        //     barcode: {
        //         text: data,
        //         format: symbology
        //     },
        //     handled: false
        // };

        // for (const handler of this.barcodeReceivers) {
        //     if (typeof (handler.func) === 'function') {
        //         handler.func(event);

        //         if (event.handled) {
        //             break;
        //         }
        //     }
        // }

        // if (!event.handled) {
        //     this.barcodeReceived.next({
        //         text: data,
        //         format: symbology
        //     });
        // }
    }

    initNavigator() {
        if (!this.launchNavigator.isAvailable()) {
            return;
        }

        const googleApiKey = AppConfig.current.einstellungen.GoogleApiKey;

        if (googleApiKey) {
            this.launchNavigator.setApiKey(googleApiKey)
                .then(() => { log?.debug(`setApiKey ${googleApiKey} success`); })
                .catch((err) => { log.warn(`setApiKey ${googleApiKey} failed: ${err}`); });
        }
    }

    private async initFileLogger() {
        log?.info('initFileLogger');

        if (MyApp.isCordovaAvailable()) {
            log?.info('initFileLogger cordova available');

            Logger.fileLogger = new AppFileLogger(this.file, this.platform);
            Logger.fileLogger.init({
                logDir: 'logfiles',
                enableMetaLogging: false,
                fileMaxLines: 10000,
                fileMaxSize: 1000000,
                totalLogSize: 5000000,
            });
        }

        log?.debug('initFileLogger done');
    }

    private async initFileDownload() {
        log?.info('initFileDownload');

        this.filedownloadQueue = await AppStorage.current.get('download-file-queue', true, false);

        if (!this.filedownloadQueue) {
            this.filedownloadQueue = [];
        }

        log?.debug('initFileDownload done');
    }

    private onAppConfigChanged() {
        log?.debug('onAppConfigChanged. initialized=' + this.initialized);

        try {
            Logger.fileLoggerAktiv = AppConfig.current.einstellungen.FileLoggerAktiv == 'ja';

            const appConfig = AppConfig.current;

            const configStr = `${appConfig.mandant};${appConfig.geraeteNummer};${appConfig.token}`;

            if (configStr != this.lastConfigStr) {
                this.lastConfigStr = configStr;

                if (AppConfig.current.token) {
                    this.initWebSocket('onAppConfigChanged');
                }

                this.initPushNotifications();
            }

            this.initNavigator();

            const spracheAendernErlaubt = Utils.isTrue(AppConfig.current.einstellungen.SpracheWechseln);
            const standardSprache = AppConfig.current.einstellungen.SpracheStandard;

            if (standardSprache) {
                let setzeStandardSprache = false;

                if (!spracheAendernErlaubt) {
                    // Anwender darf die Sprache nicht ändern, deshalb immer die Standard-Sprache setzen
                    setzeStandardSprache = true;
                } else if (!AppConfig.current.language) {
                    // Es ist noch keine Sprache gesetzt. Deshalb die Standard-Sprache verwenden.
                    setzeStandardSprache = true;
                }

                if (setzeStandardSprache) {
                    if (AppConfig.current.language != standardSprache) {
                        log?.info(`Setze Standard-Sprache: ${standardSprache}, aktuell: ${appConfig.language}`);
                        MyApp.current.setLanguage(standardSprache);
                    }
                }
            }

            if (this.gpsWatcherId && !MyApp.current.positionenAufzeichnen) {
                // GPS-Positionen sollen nicht mehr aufgezeichnet werden.
                // this.stopBackgroundGeolocation();
            }
        } catch (err) {
            log.error('onAppConfigChanged: ' + Utils.getErrorMessage(err), err);
        }
    }

    async getCurrentPosition(): Promise<GpsLocation> {
        try {
            const location = await Geolocation.getCurrentPosition({
                timeout: MyApp.current.GpsPositionTimeout,
                enableHighAccuracy: true,
                maximumAge: 3000
            });

            return {
                latitude: location.coords.latitude,
                longitude: location.coords.longitude,
                time: location.timestamp
            } as any;
        } catch (err) {
            log.warn('getCurrentPosition: ' + Utils.getErrorMessage(err, true));
            return null;
        }
    }

    async getExakteGpsPosition(info: string, loadingAnzeigen = true): Promise<GpsPosition> {
        log?.debug('getExakteGpsPosition: ' + info);

        let loadingWiederSetzen = false;

        if (loadingAnzeigen) {
            if (MyApp.isLoading()) {
                loadingWiederSetzen = true;
                MyApp.loading(false);
            }

            await UiHelper.showLoading('Exakte GPS-Position wird ermittelt...');
        }

        if (!MyApp.isCordovaAvailable()) {
            await MyApp.delay(1000);
        }

        const timeout = Date.now() + 10000;

        try {
            for (let i = 0; i < 30; i++) {
                try {
                    const location = await Geolocation.getCurrentPosition({
                        timeout: MyApp.current.GpsPositionTimeout,
                        enableHighAccuracy: true,
                        maximumAge: 3000
                    });

                    if (location && location.coords && location.coords.accuracy <= MyApp.current.PositionenExaktMeter) {
                        const gpsPosition: GpsPosition = {
                            Latitude: location.coords.latitude,
                            Longitude: location.coords.longitude,
                            Accuracy: location.coords.accuracy,
                            Altitude: location.coords.altitude,
                            Bearing: location.coords.heading,
                            Speed: location.coords.speed,
                            Timestamp: location.timestamp
                        }

                        this.letzteGpsPosition = gpsPosition;
                        this.letzteGpsPositionDate = Date.now();

                        if (loadingAnzeigen) {
                            const toast = await this.toastController.create({
                                message: 'GPS-Position erfasst',
                                duration: 1500,
                                color: 'success'
                            });

                            toast.present();

                            await Utils.delay(1000);
                        }

                        return gpsPosition;
                    }
                } catch (err) {
                    log.warn('getExakteGpsPosition: ' + Utils.getErrorMessage(err, true));
                }

                await Utils.delay(1000);

                if (Date.now() > timeout) {
                    break;
                }
            }
        } finally {
            if (loadingAnzeigen) {
                await UiHelper.hideLoading();
            }

            if (loadingWiederSetzen) {
                MyApp.loading(true);
            }
        }

        log.warn('getExakteGpsPosition: Position konnte nicht ermittelt werden');

        return null;
    }

    async getAktuelleGpsPositionStr(info: string, maxAlterSekunden = 10): Promise<string> {
        let gpsPosition = await this.getAktuelleGpsPosition(info, maxAlterSekunden);
        let gpsWert = '';

        if (gpsPosition?.Latitude) {
            gpsWert = `${gpsPosition.Latitude.toFixed(5)}, ${gpsPosition.Longitude.toFixed(5)}`;
        }

        return gpsWert;
    }

    async getAktuelleGpsPosition(info: string, maxAlterSekunden = 5): Promise<GpsPosition> {
        try {
            log?.debug('getAktuelleGpsPosition: ' + info);

            if (this.letzteGpsPosition && this.letzteGpsPositionDate > Date.now() - (maxAlterSekunden * 1000)) {
                // Vor 5 Sekunden wurde shcon eine Position aufgezeichnet. Zu häufig muss das auch nicht sein...
                return this.letzteGpsPosition;
            }

            if (!MyApp.isCordovaAvailable()) {
                await MyApp.delay(1000);
            }

            const location = await Geolocation.getCurrentPosition({
                timeout: MyApp.current.GpsPositionTimeout,
                enableHighAccuracy: true,
                maximumAge: maxAlterSekunden > 0 ? maxAlterSekunden * 1000 : 5000
            });

            const gpsPosition: GpsPosition = {
                Latitude: location.coords.latitude,
                Longitude: location.coords.longitude,
                Accuracy: location.coords.accuracy,
                Altitude: location.coords.altitude,
                Bearing: location.coords.heading,
                Speed: location.coords.speed,
                Timestamp: location.timestamp
            }

            this.letzteGpsPosition = gpsPosition;
            this.letzteGpsPositionDate = Date.now();

            return gpsPosition;
        } catch (err) {
            log.warn('getAktuelleGpsPosition: ' + Utils.getErrorMessage(err, true));
            return null;
        }
    }

    async aktualisiereEinstellungen(): Promise<boolean> {
        log?.debug('aktualisiereEinstellungen');

        try {
            const appConfig = await this.getAppConfig();

            const deviceId = await this.getDeviceId();

            // TODO: Hash des schluessels mit an dern Server schicken und überprüfen
            const loginResult = await this.remoteService.login({
                appVersion: AppConfig.AppVersion,
                geraeteNummer: appConfig.geraeteNummer,
                passwort: appConfig.passwort,
                loginToken: appConfig.token,
                mandant: appConfig.mandant,
                deviceId
            });

            if (!loginResult) {
                log.warn('aktualisiereEinstellungen: REST-Antwort ist NULL. Keine Internetverbindung?');
                return false;
            }

            if (loginResult.success) {
                log?.debug('aktualisiereEinstellungen erfolgreich');

                appConfig.uebernehmeLoginResult(loginResult);

                await this.speichereAppConfig(appConfig);

                MyApp.current.refresh();

                // this.speichereEinstellungen(loginResult.einstellungen);

                this.einstellungenLetzteAktualisierung = Date.now();

                return true;
            } else {
                log?.debug('aktualisiereEinstellungen nicht erfolgreich: ' + loginResult.message);
            }
        } catch (err) {
            log.error('aktualisiereEinstellungen: ' + Utils.getErrorMessage(err), err);
        }

        return false;
    }

    async aktualisiereEinstellungenWennNotwendig(): Promise<void> {
        try {
            const intervallStunden = 12;

            if (this.einstellungenLetzteAktualisierung > Date.now() - intervallStunden * 60 * 60 * 1000) {
                // Einstellungen wurden in den letzten {intervallStunden} Stunden schon aktualisiert
                return;
            }

            if (MyApp.internetAvailable.getValue()) {
                const appConfig = AppConfig.current;

                if (appConfig.mandant && appConfig.geraeteNummer && appConfig.host) {
                    const ok = await this.aktualisiereEinstellungen();

                    if (!ok) {
                        // Login fehlgeschlagen etc.
                        // Erst in einer Stunde wieder probieren
                        this.einstellungenLetzteAktualisierung = Date.now() - (intervallStunden - 1) * 60 * 60 * 1000;
                    }
                }
            }
        } catch (err) {
            log.error('aktualisiereEinstellungenWennNotwendig: ' + Utils.getErrorMessage(err), err);
        }
    }

    async getAppConfig(): Promise<AppConfig> {
        if (this.appConfigGeladen) {
            return AppConfig.current;
        }

        if (this.appConfigWirdGeladen) {
            log?.debug("appConfigWirdGeladen...");

            return new Promise<AppConfig>((resolve, reject) => {
                const subscription = this.appConfigGeladenEvent.subscribe(() => {
                    log?.debug("appConfigGeladenEvent");
                    subscription.unsubscribe();
                    resolve(AppConfig.current);
                });
            });
        }

        log?.debug('getAppConfig');
        await this.ladeAppConfig();

        return AppConfig.current;
    }

    async speichereAppConfig(model: AppConfig) {
        await AppStorage.current.set('einstellungen', model, true, true);

        AppConfig.changed.next();
    }

    async speichereEinstellungen(appEinstellungen: AppEinstellungen) {
        log?.debug('speichereEinstellungen', appEinstellungen);

        const appConfig = await this.getAppConfig();

        appConfig.einstellungen = appEinstellungen;

        await this.speichereAppConfig(appConfig);

        MyApp.current.refresh();
    }

    async ladeAppConfig(): Promise<void> {
        log?.info('ladeAppConfig');

        if (this.appConfigGeladen) {
            log?.debug('appConfig bereits geladen. abbruch');
            return;
        }

        this.appConfigWirdGeladen = true;

        try {
            const savedAppConfig: AppConfig = await AppStorage.current.get('einstellungen', true, true);

            log?.info('appConfig', savedAppConfig);

            if (savedAppConfig) {
                AppConfig.current.mandant = savedAppConfig.mandant;
                AppConfig.current.geraeteNummer = savedAppConfig.geraeteNummer;
                AppConfig.current.schluessel = savedAppConfig.schluessel;
                AppConfig.current.passwort = savedAppConfig.passwort;
                AppConfig.current.token = savedAppConfig.token;
                AppConfig.current.gekoppelteDrucker = savedAppConfig.gekoppelteDrucker;
                AppConfig.current.gekoppelteWaagen = savedAppConfig.gekoppelteWaagen;
                AppConfig.current.UnterMandant = savedAppConfig.UnterMandant;
                AppConfig.current.GeraeteGruppe = savedAppConfig.GeraeteGruppe;
                AppConfig.current.GeraeteBezeichnung = savedAppConfig.GeraeteBezeichnung;
                AppConfig.current.darkMode = savedAppConfig.darkMode;
                AppConfig.current.Anlagen = savedAppConfig.Anlagen;
                AppConfig.current.aktuelleAnlage = savedAppConfig.aktuelleAnlage;

                if (savedAppConfig.host) {
                    AppConfig.current.setHost(savedAppConfig.host);
                }

                if (savedAppConfig.language && savedAppConfig.language.length == 2) {
                    MyApp.current.setLanguage(savedAppConfig.language);
                }

                AppConfig.current.einstellungen = savedAppConfig.einstellungen;
            }

            if (!AppConfig.current.gekoppelteDrucker) {
                AppConfig.current.gekoppelteDrucker = [];
            }

            if (!AppConfig.current.gekoppelteWaagen) {
                AppConfig.current.gekoppelteWaagen = [];
            }

            if (!AppConfig.current.host) {
                AppConfig.current.setHost(environment.host);
            }

            if (AppConfig.current.host == 'https://recomobil-app.zilles-it.com') {
                AppConfig.current.setHost(environment.host);
            }

            if (!AppConfig.current.einstellungen) {
                AppConfig.current.einstellungen = {};
            }

            if (!AppConfig.current.token) {
                AppConfig.current.token = '';
            }

            if (!AppConfig.current.Anlagen) {
                AppConfig.current.Anlagen = [];
            }

            this.appConfigGeladen = true;
            this.appConfigWirdGeladen = false;
            this.appConfigGeladenEvent.next();

            AppConfig.loaded.next(AppConfig.current);

            log?.info('appConfig result', savedAppConfig);

            MyApp.current.refresh();
            MyApp.current.geladen.next(true);
        } catch (err) {
            log.error('ladeAppConfig: ' + Utils.getErrorMessage(err), err);
        } finally {
            this.appConfigGeladen = true;
            this.appConfigWirdGeladen = false;
            this.appConfigGeladenEvent.next();
        }
    }

    async sendeTextdatei(textdatei: Textdatei, mitGpsPosition: boolean) {
        log?.debug('sendeTextdatei', textdatei);

        if (!this.postausgangOrdnerVorhanden) {
            await this.mkdirPostausgang();
        }

        let id = Date.now();

        if (id <= this.lastPostausgangId) {
            // Sicherstellen, dass die ID eindeutig ist. Es könnte theoretisch passieren, dass innerhalb von 1 Millisekunde zwei Dateien geschrieben werden.
            id = this.lastPostausgangId + 1;
        }

        this.lastPostausgangId = id;

        const filename = id + '.json';

        // Merke, dass diese Datei gerade geschrieben wird.
        this.writeFileSet.add(filename);

        const writtenFiles: string[] = [];

        try {
            await this.aktualisiereTextdatei(textdatei, mitGpsPosition);

            // Speichere die Textdatei im Dateisystem.
            const json = JSON.stringify(textdatei);
            // const base64 = btoa(json);

            // große Textdateien müssen in chunks aufgeteilt werden.
            // Das tritt z.B. bei Aufträgen mit vielen Fotos auf.
            const chunkSize = 1024 * 1024; // 1 MB
            let counter = 0;

            for (let i = 0; i < json.length; i += chunkSize) {
                const chunk = json.slice(i, i + chunkSize);

                // Speichere die Chunks so ab:
                // 1. Datei: 1234567890.json
                // 2. Datei: 1234567890.json.1
                // 3. Datei: 1234567890.json.2

                let myFilename = counter == 0 ? filename : filename + '.' + counter;

                const filePath = Constants.POSTAUSGANG + '/' + myFilename;

                await Filesystem.writeFile({
                    path: filePath,
                    data: chunk,
                    directory: Directory.Data,
                    encoding: Encoding.UTF8,
                    recursive: true
                });

                writtenFiles.push(filePath);
                counter++;
            }
        } catch (err) {
            log.error('sendeTextdatei: ' + Utils.getErrorMessage(err), err);

            // Cleanup: Lösche alle bereits geschriebenen Chunks
            // Besonders beim späteren JSON.Parse kann es zu Fehlern kommen, 
            for (const path of writtenFiles) {
                await FileHelper.deleteFileEx(Directory.Data, path);
            }
        } finally {
            // Datei ist fertig geschrieben.
            // immer freigeben, auch bei Fehlern. Ansonsten bleibt der Sendeprozess hängen.
            this.writeFileSet.delete(filename);
        }

        // Hier extra kein await
        this.sendePostausgang();
    }

    async mkdirPostausgang() {
        log?.debug('mkdirPostausgang');

        this.postausgangOrdnerVorhanden = true;

        await FileHelper.mkdir(Directory.Data, Constants.POSTAUSGANG);
    }

    async loescheAllePostausgangDateien() {
        try {
            await this.mkdirPostausgang();

            const list = await Filesystem.readdir({
                path: Constants.POSTAUSGANG,
                directory: Directory.Data
            });

            for (const file of list.files) {
                try {
                    await Filesystem.deleteFile({
                        path: Constants.POSTAUSGANG + '/' + file.name,
                        directory: Directory.Data
                    });
                } catch (e) {
                    log.warn('loescheAllePostausgangDateien: ' + Utils.getErrorMessage(e), e);
                }
            }
        } catch (e) {
            log.error('loescheAllePostausgangDateien: ' + Utils.getErrorMessage(e), e);
        }
    }

    async loescheAlleDateien() {
        let ordnerListe = [
            'dokumente',
            'files',
            'cache',
            'logfiles',
            'data',
            'postausgang'
        ];

        for (const ordner of ordnerListe) {
            try {
                // Ordner löschen
                await FileHelper.rmdir(Directory.Data, ordner);

                // Ordner wieder anlegen
                await FileHelper.mkdir(Directory.Data, ordner);
            } catch (e) {
                log.warn('loescheAlleDateien ' + ordner + ': ' + Utils.getErrorMessage(e), e);
            }
        }

        // Dateien mit diesem Prefix löschen
        let dateiPrefixes = [
            'Checkliste',
            'auftrag-',
            'fuehrerscheinkontrolle'
        ]

        try {
            const result = await Filesystem.readdir({
                path: '',
                directory: Directory.Data,
            });

            for (let file of result.files) {
                if (file.type === 'file') {
                    if (dateiPrefixes.some(prefix => file.name.startsWith(prefix))) {
                        await FileHelper.deleteFileEx(Directory.Data, file.name);
                    }
                } else if (file.type === 'directory') {
                    // Ordner die eine GUID als Dateiname haben auch löschen
                    if (file.name.length >= 32) {
                        if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(file.name)) {
                            await FileHelper.rmdir(Directory.Data, file.name);
                        }
                    }
                }
            }
        } catch (e) {
            log.error('error readdir: ' + Utils.getErrorMessage(e, true), e);
        }

        // Testweise noch alle Dateien loggen
        await this.logAllFilesRecursive('');
    }

    async logAllFilesRecursive(path: string) {
        try {
            const result = await Filesystem.readdir({
                path: path,
                directory: Directory.Data,
            });

            for (let file of result.files) {
                const fullPath = path ? `${path}/${file.name}` : file.name;

                if (file.type === 'directory') {
                    log?.debug('Ordner:', fullPath);

                    // Rekursion: Geh einen Schritt tiefer
                    await this.logAllFilesRecursive(fullPath);
                } else {
                    log?.debug('Datei:', fullPath);
                }
            }
        } catch (e) {
            log.error('Konnte Verzeichnis nicht lesen: ' + path, e);
        }
    }

    async aktualisiereTextdatei(textdatei: Textdatei, mitGpsPosition: boolean): Promise<void> {
        log?.debug('aktualisiereTextdatei');

        try {
            textdatei.AppVersion = this.versionNumber;

            if (mitGpsPosition) {
                // Die GPS-Position darf auch etwas älter sein (45 Sekunden ist normalerweise ok).
                // Ansonsten wird bei jeder Statusmeldung imemr relativ lange das Ladesymbol angezeigt.
                textdatei.Position = await this.getAktuelleGpsPosition('Status', 45);
            }

            if (!textdatei.DeviceInfo) {
                textdatei.DeviceInfo = {};
            }

            textdatei.DeviceInfo['SYSTEM_ALERT_WINDOW'] = AppConfig.current.permissionSystemAlertWindow ? 'ja' : 'nein';

            const device = (window as any).device;

            if (device?.available) {
                textdatei.DeviceInfo['platform'] = device.platform;
                textdatei.DeviceInfo['version'] = device.version;
                textdatei.DeviceInfo['uuid'] = device.uuid;
                textdatei.DeviceInfo['cordova'] = device.cordova;
                textdatei.DeviceInfo['model'] = device.model;
                textdatei.DeviceInfo['manufacturer'] = device.manufacturer;
                textdatei.DeviceInfo['sdkVersion'] = device.sdkVersion;
            }
        } catch (err) {
            log.error('aktualisiereTextdatei: ' + Utils.getErrorMessage(err), err);
        } finally {
            log?.debug('aktualisiereTextdatei done');
        }
    }

    async updateAnzahlPostausgangNachrichten() {
        try {
            const app = MyApp.current;

            await MyApp.ready();

            // Prüfe die Anzahl der Nachrichten im Postausgang-Ordner
            const result = await Filesystem.readdir({
                path: 'postausgang',
                directory: Directory.Data,
            });

            let jsonFiles = result.files.filter(f => f && f.name && f.name.endsWith('.json'));

            Utils.next(app.anzahlPostausgangNachrichten, jsonFiles.length);
        } catch (err) {
            log.error(Utils.getErrorMessage(err), err);
        }
    }

    /**
     * Versucht alle Nachrichten im Postausgang an den Server zu schicken.
     */
    async sendePostausgang() {
        if (this.sendenPostausgangLaeuft) {
            return;
        }

        log?.debug('sendePostausgang');

        this.sendenPostausgangLaeuft = true;

        const app = MyApp.current;

        if (!this.postausgangOrdnerVorhanden) {
            await this.mkdirPostausgang();
        }

        try {
            await MyApp.ready();

            let ttl = 10;

            do {
                // Prüfe die Anzahl der Nachrichten im Postausgang-Ordner
                const dirResult = await Filesystem.readdir({
                    path: Constants.POSTAUSGANG,
                    directory: Directory.Data,
                });

                let jsonFiles = dirResult.files.filter(f => f && f.name && f.name.endsWith('.json'));

                Utils.next(app.anzahlPostausgangNachrichten, jsonFiles.length);

                if (!jsonFiles.length) {
                    return;
                }

                // Sortiere die Dateien nach Name aufsteigend. So werden die ältesten Nachrichten zuerst gesendet.
                // Es ist wichtig, dass die Dateien immer in der gleichen Reihenfolge gesendet werden, damit sie auch in dieser Reihenfolge vom SErver verarbeitet werden.
                jsonFiles.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));

                log?.debug(`sendePostausgang: ${jsonFiles.length} Textdateien gefunden`);

                if (!MyApp.isInternetAvailable()) {
                    log?.info('sendePostausgang abgebrochen. Keine Internetverbindung.');
                    break;
                }

                for (const fileInfo of jsonFiles) {
                    log?.info('sendePostausgang: ' + fileInfo.name);

                    if (!MyApp.isInternetAvailable()) {
                        log?.info('senden abgebrochen. Keine Internetverbindung.');

                        // Setze ttl auf 0. Wenn keine Internetverbindung vorhanden ist können wir direkt abbrechen.
                        ttl = 0;
                        break;
                    }

                    // Prüfe ob die Datei gerade geschrieben wird
                    if (this.writeFileSet.has(fileInfo.name)) {
                        log?.info('sendePostausgang: Datei wird gerade geschrieben. Abbruch: ' + fileInfo.name);

                        // Hier komplett abbrechen. Es sollen auch nicht die nachfolgenden Dateien gesendet werden.
                        // Das ist vorallem bei gesplitteten Dateien wichtig. Es wird nur der erste Dateiname in das writeFileSet aufgenommen.

                        // Setze ttl auf 0 damit die äußere Schleife auch abgebrochen wird.
                        ttl = 0;
                        break;
                    }

                    if (this.errorFileSet.has(fileInfo.name)) {
                        // Ignoriere diese Datei, da sie definitiv fehlerhaft ist und nicht gesendet werden kann.
                        log?.debug(`sendePostausgang: Datei fehlerhaft. Wird ignoriert: ${fileInfo.name}`);
                        continue;
                    }

                    const filePath = Constants.POSTAUSGANG + '/' + fileInfo.name;

                    const content = await Filesystem.readFile({
                        path: filePath,
                        directory: Directory.Data,
                        encoding: Encoding.UTF8
                    });

                    // log?.debug('Datei gelesen: ' + content.data.s(0, 100) + '...');

                    let filePathList: string[] = [];
                    filePathList.push(filePath);

                    let json = content.data as string;

                    // Prüfe ob es noch mehrere Parts gibt die angehängt werden müssen
                    // Die Dateien sind dann so abgespeichert:
                    // 1. Datei: 1234567890.json
                    // 2. Datei: 1234567890.json.1
                    // 3. Datei: 1234567890.json.2

                    // Maximal 1000 Teile pro Nachricht
                    for (let i = 1; i <= 1000; i++) {
                        const partFileName = fileInfo.name + '.' + i;

                        // Prüfe ob diese Datei existiert
                        const partFile = dirResult.files.find(f => f.name === partFileName);

                        if (!partFile) {
                            // Keine weitere Datei mehr vorhanden
                            break;
                        }

                        const partFilePath = Constants.POSTAUSGANG + '/' + partFileName;

                        // Datei lesen
                        const partContent = await Filesystem.readFile({
                            path: partFilePath,
                            directory: Directory.Data,
                            encoding: Encoding.UTF8
                        });

                        //log?.debug('Part-Datei gelesen: ' + partContent.data);

                        // Merke den Pfad der Part-Datei zum späteren Löschen
                        filePathList.push(partFilePath);

                        // An den JSON-String anhängen
                        json += partContent.data as string;
                    }

                    let sendenErfolgreich = false;

                    for (let i = 0; i < 10; i++) {
                        if (!MyApp.isInternetAvailable()) {
                            break;
                        }

                        try {
                            let sendResult: SendResult;

                            if (MyApp.HTTP_COMPRESSION_ENABLED) {
                                // const json = JSON.stringify(textdatei);
                                const zipped = Utils.compress(json);

                                log?.debug('sendTextdateiZipped: ' + zipped.byteLength + ' Bytes (' + i + ')');

                                sendResult = await this.remoteService.sendTextdateiZipped(zipped);
                            } else {
                                log?.debug('sendTextdateiPlain: ' + json.substring(0, 100) + '...');

                                let textdatei: Textdatei;

                                try {
                                    textdatei = JSON.parse(json);
                                } catch (err) {
                                    log.error('Fehler beim JSON.parse der Textdatei: ' + Utils.getErrorMessage(err));

                                    // Ignoriere diese Datei in Zukunft, damit der Sendeprozess nicht immer wieder bei dieser Datei hängen bleibt.
                                    this.errorFileSet.add(fileInfo.name);

                                    // Schleife verlassen
                                    i = 100;

                                    throw err;
                                }

                                sendResult = await this.remoteService.sendTextdateiPlain(textdatei);
                            }

                            if (!sendResult) {
                                // Fehler bei der Kommunikation mit dem Server (kein internet?)
                                log.warn('Fehler beim senden der Textdatei (Kommunikation)');
                                sendenErfolgreich = false;
                                await Utils.delay(5000);
                                continue;
                            }

                            if (sendResult.success) {
                                sendenErfolgreich = true;
                                break;
                            } else {
                                log.warn('Fehler beim senden der Textdatei (Server): ' + sendResult.message);
                                sendenErfolgreich = false;

                                await Utils.delay(1000);
                            }
                        } catch (err) {
                            const errorMessage = Utils.getErrorMessage(err);
                            log.warn('Fehler beim senden der Textdatei (Client): ' + errorMessage);
                            sendenErfolgreich = false;

                            if (errorMessage && errorMessage.indexOf('ERR_CONNECTION_REFUSED') >= 0) {
                                await Utils.delay(10000);
                            } else {
                                await Utils.delay(1000);
                            }
                        }

                        if (sendenErfolgreich) {
                            break;
                        }
                    }

                    if (sendenErfolgreich) {
                        // Lösche die lokale Nachricht
                        log?.debug('Senden erfolgreich: ' + fileInfo);

                        for (const filePath of filePathList) {
                            try {
                                await Filesystem.deleteFile({
                                    path: filePath,
                                    directory: Directory.Data,
                                });
                            } catch (err) {
                                log.warn('Fehler beim Löschen der Textdatei ' + filePath + ': ' + Utils.getErrorMessage(err), err);
                            }
                        }
                    } else {
                        if (MyApp.isInternetAvailable()) {
                            log.warn('Textdatei konnte auch nach 10 Versuchen nicht versendet werden. Abbruch')
                        } else {
                            log.warn('Textdatei konnte auch nach 10 Versuchen nicht versendet werden. Abbruch da keine Internetverbindung vorhanden.')
                        }

                        break;
                    }
                }
            } while (ttl-- > 0);
        } finally {
            this.sendenPostausgangLaeuft = false;
        }

        // Utils.next(app.anzahlPostausgangNachrichten, 0);

        log?.debug('sendePostausgang FERTIG');
    }

    // async speicherePostausgang(): Promise<void> {
    //     await AppStorage.current.set('postausgang', this.postausgang, false);
    // }

    // async getPostausgang(): Promise<Postausgang> {
    //     if (this.postausgang == null) {
    //         this.postausgang = await AppStorage.current.get('postausgang', true, false);

    //         if (!this.postausgang) {
    //             this.postausgang = {
    //                 lastId: 0,
    //                 textdateiIds: []
    //             };
    //         }
    //     }

    //     if (!this.postausgang.lastId) {
    //         this.postausgang.lastId = 0;
    //     }

    //     if (!this.postausgang.textdateiIds) {
    //         this.postausgang.textdateiIds = [];
    //     }

    //     return this.postausgang;
    // }

    private connectivityChanged(connected: boolean) {
        log?.debug('connectivityChanged: ' + connected + ', initialized=' + this.initialized);

        if (connected && this.initialized) {
            this.sendePostausgang();

            if (!this.webSocket) {
                setTimeout(() => {
                    try {
                        if (!this.webSocket) {
                            this.initWebSocket('connectivityChanged');
                        }
                    } catch (err) {
                        log.error('setTimeout connectivityChanged: ' + Utils.getErrorMessage(err), err);
                    }
                }, 500);
            }
        }
    }

    private cancelAllPendingWebSocketMessages(): void {
        const sendIds = [...this.webSocketSendPending.keys()];

        for (const id of sendIds) {
            this.finishWebSocketSend(id, false);
        }
    }

    private finishWebSocketSend(sendId: number, ok: boolean): void {
        const pending = this.webSocketSendPending.get(sendId);

        if (!pending) {
            log.warn('finishWebSocketSend: kein Pending (abgebrochen oder Timeout): ' + sendId);
            return;
        }

        // Lösche den Timeout
        clearTimeout(pending.timeoutId);

        // Entferne die Nachricht aus der Liste der ausstehenden Nachrichten
        this.webSocketSendPending.delete(sendId);

        // Resolve den Promise
        pending.resolve(ok);
    }

    private async initWebSocket(info: string): Promise<void> {
        log?.debug('initWebSocket: ' + info);

        this.cancelAllPendingWebSocketMessages();

        this.lastMessageReceived = Date.now();

        this.webSocketStatus.next('connecting');
        this.webSocketConnected.next(false);

        const host = this.remoteService.getAktiverHost().url
            .toLowerCase()
            .replace("https://", "wss://")
            .replace("http://", "ws://");

        const url = host + '/ws';

        log?.info('Connecting web socket to ' + url);

        if (this.webSocket) {
            this.webSocket.close();
            this.webSocket = null;
        }

        this.webSocket = new WebSocket(url);

        this.webSocket.onmessage = (ev: MessageEvent) => {
            log?.debug('webSocket.onmessage');

            try {
                log?.debug('onmessage', ev);

                if (this.webSocketStatus.getValue() != 'OK') {
                    this.webSocketStatus.next('OK');
                }

                if (!this.webSocketConnected.getValue()) {
                    this.webSocketConnected.next(true);
                }

                const data = ev.data;

                if (typeof (data) === 'string') {
                    this.verarbeiteWebSocketMessage(data as string);
                } else if (typeof (data) === 'object') {
                    log.error('Noch nicht implementiert !', ev);
                }
            } catch (err) {
                log.error('webSocket.onmessage', err);
            }
        };

        this.webSocket.onopen = async (ev: Event) => {
            log?.info('webSocket.onopen');

            try {
                this.webSocketStatus.next('connected');
                this.webSocketConnected.next(true);
                await this.sendeWebSocketLoginMessage();
                await this.pingWebSocket(true);
            } catch (err) {
                log.warn('onopen', err);
            }
        };

        this.webSocket.onclose = (ev: CloseEvent) => {
            log?.info('webSocket.onclose');
            this.cancelAllPendingWebSocketMessages();
            this.webSocketStatus.next('disconnected');
            this.webSocketConnected.next(false);
        };

        this.webSocket.onerror = (ev: Event) => {
            log?.warn('webSocket.onerror', ev);
            this.webSocketStatus.next('disconnected');
            this.webSocketConnected.next(false);
        };

        this.webSocket.addEventListener('close', () => {
            log?.info('webSocket.close');
            this.webSocketStatus.next('disconnected');
            this.webSocketConnected.next(false);
        });
    }

    async sendeWebSocketLoginMessage() {
        log?.debug('sendeWebSocketLoginMessage');

        const deviceId = await this.getDeviceId();

        await this.sendWebSocketMessage({
            t: PushMessageType.Login,
            m: AppConfig.current.mandant,
            g: AppConfig.current.geraeteNummer,
            x: AppConfig.current.token,
            d: deviceId,
            v: this.versionNumber
        } as LoginPushMessage, 'login');
    }

    async initBackgroundMode() {
        log?.info('initBackgroundMode');

        try {
            if (AppConfig.current.anwendungAktivLassen) {
                if (!this.isCordovaAvailable()) {
                    log.warn('Cordova nicht verfügbar. Background-Mode wird nicht aktiviert');
                    return;
                }

                log?.info("Aktiviere Background-Mode");


                // TODO CAPACITOR: funktioniert nicht mehr. Muss anders implementiert werden

                BackgroundMode.addListener('appInBackground', () => {
                    try {
                        log?.info('backgroundMode activated -> App is now in background');

                        // Various APIs like playing media or tracking GPS position in background might not work while in background even the
                        // background mode is active. To fix such issues the plugin provides a method to disable most optimizations done by Android/CrossWalk.
                        BackgroundMode.disableWebViewOptimizations();

                        // https://github.com/katzer/cordova-plugin-background-mode/issues/430
                        // .disableBatteryOptimizations();

                        this.istImVordergrund.next(false);

                        setTimeout(() => { this.update('backgroundMode activated'); }, 10 * 1000);
                    } catch (err) {
                        log.error('appInBackground: ' + Utils.getErrorMessage(err), err);
                    }
                });

                BackgroundMode.addListener('appInForeground', () => {
                    try {
                        log?.info('backgroundMode deactivated -> App is now in foreground');
                        LocalNotifications.removeAllDeliveredNotifications();

                        this.istImVordergrund.next(true);
                    } catch (err) {
                        log.error('appInForeground: ' + Utils.getErrorMessage(err), err);
                    }
                });

                this.platform.pause.subscribe(() => {
                    log?.info('backgroundMode pause -> moving to background');
                    // this.backgroundMode.excludeFromTaskList();
                    //// this.backgroundMode.moveToBackground();
                });

                await BackgroundMode.requestNotificationsPermission();
                await BackgroundMode.requestMicrophonePermission();
                await BackgroundMode.requestDisableBatteryOptimizations();

                await BackgroundMode.enable({
                    allowClose: false,
                    disableWebViewOptimization: true,

                    // Title of the background task
                    title: 'ReCoMobil',

                    // Description of background task
                    text: 'Anwendung läuft im Hintergrund',

                    // Silent muss hier auf FALSE gsetzt werden. Ansonsten wird nach ein paar Sekunden eine Fehlermeldung angezeigt "ReCoMobil reagiert nicht"
                    silent: false,

                    // icon: 'icon' // this will look for icon.png in platforms/android/res/drawable|mipmap
                    // color: 'F14F4D', // hex format like 'F14F4D'

                    // By default the app will come to foreground when tapping on the notification. If false, plugin won't come to foreground when tapped.
                    resume: true,

                    // When set to false makes the notifications visible on lock screen (Android 5.0+)
                    hidden: true,

                    // The text that scrolls itself on statusbar
                    // ticker: undefined,

                    // hidden: Boolean,
                    bigText: true
                });

                await BackgroundMode.moveToForeground();

                log?.info('backgroundMode acquire powerManagement');

                this.powerManagement.acquire()
                    .then(res => log?.info('Wakelock aquire'))
                    .catch(res => log.warn('Error Wakelock acquired'));

                this.powerManagement.setReleaseOnPause(false)
                    .then(res => log?.info('setReleaseOnPause successfully'))
                    .catch(res => log.warn('Failed to set ReleaseOnPause'));

            } else {
                log?.info("Background-Mode ist deaktiviert");
            }
        } catch (err) {
            log.error('initBackgroundMode', err);
        }

        log?.debug('initBackgroundMode done');
    }

    // moveToForeground() {
    //     log?.info('moveToForeground');

    //     try {
    //         if (this.backgroundMode.isActive()) {
    //             // Turn screen on
    //             this.backgroundMode.wakeUp();

    //             // Turn screen on and show app even locked
    //             this.backgroundMode.unlock();
    //         }
    //     } catch (err) {
    //         log.error('moveToForeground', err);
    //     }
    // }

    async initRingtones() {
        log?.debug('initRingtones');

        try {
            if (!this.isCordovaAvailable()) {
                log.warn('Cordova nicht verfügbar. Ringtones werden nicht geladen');
                this.verfuegbareKlingeltoene = [];
                return;
            }

            this.ringtonesInitialisiert = true;

            await NativeAudio.preload({ assetId: '1', assetPath: 'public/assets/ringtones/1.mp3', audioChannelNum: 1, isUrl: false });
            await NativeAudio.preload({ assetId: '2', assetPath: 'public/assets/ringtones/2.mp3', audioChannelNum: 1, isUrl: false });
            await NativeAudio.preload({ assetId: '3', assetPath: 'public/assets/ringtones/3.mp3', audioChannelNum: 1, isUrl: false });
            await NativeAudio.preload({ assetId: 'definite', assetPath: 'public/assets/ringtones/definite.mp3', audioChannelNum: 1, isUrl: false });

            log?.debug('init ringtones result');
        } catch (err) {
            log.error('initRingtones', err);
        }
    }

    getVerfuegbareKlingeltoene(): Ringtone[] {
        return this.verfuegbareKlingeltoene;
    }

    async beepFuerNeueNachricht() {
        log?.debug('beepFuerNeueNachricht');

        if (!this.isCordovaAvailable()) {
            log?.debug('beepFuerNeueNachricht (cordova nicht verfügbar)');
            return;
        }

        try {
            // if (!this.ringtonesInitialisiert) {
            //     log?.debug('beepFuerNeueNachricht (ringtones nicht initialisiert)');
            //     await this.initRingtones();
            // }

            (navigator as any).notification.beep(1);

            // const assetId = 'definite';
            // const volume = App.current.NachrichtenSoundLautstaerke.getValue() / 100.0;

            // this.nativeAudio.setVolumeForComplexAsset(assetId, volume);

            // await this.nativeAudio.play(assetId, () => { });
        } catch (err) {
            log.error('beepFuerNeueNachricht: ' + Utils.getErrorMessage(err));
        }
    }

    async starteKlingeln() {
        log?.info(`starteKlingeln`);

        if (this.klingelnAktiv) {
            log?.info('starteKlingeln: Klingeln bereits aktiv');
            return;
        }

        this.klingelnAktiv = true;

        if (!this.isCordovaAvailable()) {
            return;
        }

        try {
            if (!this.ringtonesInitialisiert) {
                await this.initRingtones();

                await Utils.delay(500);
            }

            log?.info(`starteKlingeln: 2`);
            await NativeAudio.play({ assetId: '2' });

            this.klingelnIntervalId = setInterval(() => {
                if (this.klingelnAktiv) {
                    NativeAudio.play({ assetId: '2' });
                } else {
                    if (this.klingelnIntervalId) {
                        clearInterval(this.klingelnIntervalId);
                        this.klingelnIntervalId = null;
                    }
                }
            }, 5000);

        } catch (err) {
            log.error('starteKlingeln', err);
        }
    }

    async stoppeKlingeln() {
        log?.info(`stoppeKlingeln`);

        this.klingelnAktiv = false;

        if (this.klingelnIntervalId) {
            clearInterval(this.klingelnIntervalId);
            this.klingelnIntervalId = null;
        }

        if (!this.isCordovaAvailable()) {
            return;
        }

        try {
            if (!this.ringtonesInitialisiert) {
                await this.initRingtones();
            }

            log?.debug(`stoppeKlingeln: 2`);
            await NativeAudio.stop({ assetId: '2' });
        } catch (err) {
            log.warn('stoppeKlingeln', err);
        }
    }

    async initLocalNotifications(): Promise<void> {
        log?.info('initLocalNotifications');

        try {
            const cordovaAvailable = this.platform.is('cordova');

            if (!cordovaAvailable) {
                log.warn('Cordova nicht verfügbar. Local notifications werden nicht aktiviert');
                return;
            }

            const hasPermission = await LocalNotifications.checkPermissions();

            if (!hasPermission || hasPermission.display !== 'granted') {
                await LocalNotifications.requestPermissions();
            }

            LocalNotifications.registerActionTypes({
                types: [{
                    id: 'yes-no',
                    actions: [
                        { id: 'yes', title: 'Ja' },
                        { id: 'no', title: 'Nein' }
                    ]
                }]
            });

            log?.debug('initLocalNotifications done');
        } catch (err) {
            log.error('initLocalNotifications: ' + Utils.getErrorMessage(err));
        }
    }

    async initAutostart() {
        log?.info('initFileDownload');

        try {
            if (!this.isCordovaAvailable()) {
                log.warn('Cordova nicht verfügbar. Autostart wird nicht aktiviert');
                return;
            }

            // TODO CAPACITOR: https://github.com/RsknCankov/capacitor-auto-start
            // cordova.plugins.autoStart.enable();

            log.warn('TODO CAPACITOR autostart');
        } catch (err) {
            log.error('initAutostart', err);
        }

        log?.debug('initFileDownload done');
    }

    async initPushNotifications(): Promise<void> {
        log?.info('initPushNotifications');

        if (!AppConfig.current.mandant) {
            log?.debug('initPushNotifications: Push noch nicht registrieren, da Mandant nicht gesetzt');
            return;
        }

        if (!AppConfig.current.geraeteNummer) {
            log?.debug('initPushNotifications: Push noch nicht registrieren, da Gerät nicht gesetzt');
            return;
        }

        if (this.pushRegistration) {
            log?.debug('initPushNotifications: Push-Registration bereits vorhanden');

            if (AppConfig.current.mandant == this.pushRegistrationMandant) {
                if (AppConfig.current.geraeteNummer === this.pushRegistrationGeraeteNummer) {
                    log?.debug('initPushNotifications: Push-Registration bereits für Mandant und Gerät registriert');
                    return;
                }
            }

            this.processPushRegistration(this.pushRegistration);
            return;
        }

        try {
            const cordovaAvailable = this.platform.is('cordova');

            if (!cordovaAvailable) {
                log.warn('Cordova nicht verfügbar. Push wird nicht aktiviert');
                return;
            }

            // Request permission to use push notifications
            // iOS will prompt user and return if they granted permission or not
            // Android will just grant without prompting
            PushNotifications.requestPermissions().then(result => {
                // Hier kommt im normalfall {"receive":"granted" } zurück. 
                // Wenn der Anwender die Berechtigung nicht erteilt, dann kommt {"receive":"denied"} zurück
                log.info("PUSH requestPermission: " + JSON.stringify(result));

                if (result.receive && result.receive != 'denied') {
                    MyApp.current.pushPermissions.next(true);
                    // Register with Apple / Google to receive push via APNS/FCM
                    PushNotifications.register();
                } else {
                    // Show some error
                    log.warn("PUSH: no permission");
                    MyApp.current.pushPermissions.next(false);
                }
            }).catch(err => {
                log.error("PUSH requestPermission error: " + Utils.getErrorMessage(err), err);
                MyApp.current.pushPermissions.next(false);
            });

            // On success, we should be able to receive notifications
            PushNotifications.addListener('registration', (token: Token) => {
                log?.info("PUSH registration: " + token?.value);
                this.processPushRegistration(token);
            });

            // Some issue with our setup and push will not work
            PushNotifications.addListener('registrationError', (error: any) => {
                log.warn("PUSH registrationError: " + JSON.stringify(error), error);
            });

            // Show us the notification payload if the app is open on our device
            PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
                // Es wurde eine Push-Benachrichtigung empfangen
                // Diese Methode wird aber leider nur aufgerufen, wenn die App im Vordergrund ist.
                // Wenn sie im Hintergrund ist, dann stoppt capacitor die Verarbeitung von Javascript.
                this.processPushNotification(notification);
            });

            PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
                // Wird aufgerufen, wenn der Anwender auf eine Push-Benachrichtigung klickt
                // Kann eventuell mal verarbeitet werden...
                log.warn("PUSH pushNotificationActionPerformed", notification);
            });

            // // to check if we have permission
            // const res = await this.push.hasPermission();

            // if (!res.isEnabled) {
            //     log.warn('push nicht verfügbar. no permission');
            //     // return;
            // }

            // log?.info('hasPermission result', res);

            // // Es können unterschiedliche Channels eingerichtet werden, mit unterschiedlicher Prio.
            // // Brauchen wir eigentlich nicht
            // const channel = await this.push.createChannel({
            //     id: "PushPluginChannel",
            //     description: "ReCoMobil channel",
            //     // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
            //     importance: 5,
            //     vibration: true,
            //     visibility: 1
            // });

            // // log?.info('channel', channel);

            // this.pushAvailable.next(true);

            // const options: PushOptions = {
            //     android: {
            //         //  Maps to the project number in the Google Developer Console.
            //         senderID: undefined,

            //         // If true the device vibrates on receipt of notification.
            //         vibrate: true,

            //         //  If true it plays the sound specified in the push data or the default system sound
            //         sound: true,

            //         // If true the icon badge will be cleared on init and before push messages are processed.
            //         clearBadge: false,

            //         // If true will always show a notification, even when the app is on the foreground
            //         forceShow: false,

            //         // The key to search for text of notification.
            //         messageKey: undefined,

            //         // The key to search for title of notification.
            //         titleKey: undefined
            //     },
            //     ios: {
            //         alert: 'true',
            //         badge: 'true',
            //         sound: 'false'
            //     },
            //     windows: {},
            //     browser: {
            //         pushServiceURL: 'http://push.api.phonegap.com/v1/push'
            //     }
            // };

            // const pushObject: PushObject = this.push.init(options);

            // log?.debug('pushObject', pushObject);

            // pushObject.on('notification').subscribe((notification: any) => this.processPushNotification(notification));

            // pushObject.on('registration').subscribe((registration: any) => this.processPushRegistration(registration));

            // pushObject.on('error').subscribe(error => this.processPushError(error));
        } catch (err) {
            log.error('error initializing push: ' + err);
        }

        log?.debug('initPushNotifications done');
    }

    async processPushRegistration(registration: Token) {
        log?.info('push registration', registration);

        this.pushRegistration = registration;

        // App wurde am Push-Dienst registriert. Jetzt muss die registrationId an den Server geschickt werden
        const deviceId = await this.getDeviceId();
        const platform = this.getPlatform();

        try {
            const result = await this.remoteService.registerPush({
                registrationId: registration.value,
                registrationType: 'FCM',
                uniqueDeviceId: deviceId,
                platform
            });

            if (!result) {
                // Keine Antwort vom Server. Eventuell keine Internetverbindung.
                this.pushAvailable.next(false);
                this.pushRegistrationId.next('');
                this.pushRegistrationType.next('');
                this.pushRegistrationMandant = null;
                this.pushRegistrationGeraeteNummer = null;
                return;
            }

            if (result.success) {
                this.pushRegistrationMandant = AppConfig.current.mandant;
                this.pushRegistrationGeraeteNummer = AppConfig.current.geraeteNummer;
            } else {
                this.pushRegistrationMandant = null;
                this.pushRegistrationGeraeteNummer = null;
            }

            this.pushAvailable.next(true);
            this.pushRegistrationId.next(registration.value);
            this.pushRegistrationType.next('FCM');
        } catch (error) {
            // Kann passieren, wenn keine Internetverbindung besteht oder der Server nicht erreichbar ist.
            log.warn('processPushRegistration', error);
            this.pushAvailable.next(false);
            this.pushRegistrationId.next('');
            this.pushRegistrationType.next('');
            this.pushRegistrationMandant = null;
            this.pushRegistrationGeraeteNummer = null;
        }
    }

    processPushNotification(notification: PushNotificationSchema) {
        log?.info(`push notification: ${notification.data?.typ}`);

        // Selbst verarbeiten ?
        if (notification.data) {
            const typ = notification.data.typ;

            if (typ === "app-reset") {
                // Fernlöschung: Der Server fordert das Zurücksetzen der App an
                this.verarbeiteGeraetZuruecksetzen({
                    t: PushMessageType.GeraetZuruecksetzen,
                    Mandant: notification.data.mandant,
                    GeraeteNummer: notification.data.geraeteNummer
                });
                return;
            }

            if (typ === "check-update") {
                this.checkUpdate(false, true);
                return;
            }
        }

        this.pushNotificationEmpfangen.next(notification);
    }

    processPushError(error: any) {
        log?.info('push error: ' + Utils.getErrorMessage(error));
    }

    async getDeviceId(): Promise<string> {
        if (this.deviceId) {
            return this.deviceId;
        }

        log?.info('getDeviceId start');

        try {
            this.deviceId = await AppStorage.current.get('deviceId', true, true);

            if (!this.deviceId) {
                this.deviceId = Utils.uuid(); // Math.floor(Math.random() * Math.floor(99999999)).toString();
            }

            await AppStorage.current.set('deviceId', this.deviceId, true, true);

            // if (this.isCordovaAvailable()) {
            //     log?.info('getDeviceId uniqueDeviceID.get');
            //     this.deviceId = await this.uniqueDeviceID.get();
            // } else {
            //     log?.info('load deviceId from storage');
            // }
        } catch (err) {
            this.deviceId = 'unknown';
            log.error(`error getting unique device id: ${err}. using device id=${this.deviceId}`);
        }

        log?.info('deviceId: ' + this.deviceId);

        return this.deviceId;
    }

    isCordovaAvailable(): boolean {
        return MyApp.isCordovaAvailable();
    }

    getPlatform(): string {
        if (this.platform.is('ios')) {
            return 'ios';
        } else if (this.platform.is('android')) {
            return 'android';
        } else if (this.platform.is('desktop')) {
            return 'desktop';
        } else {
            return this.platform.platforms().join();
        }
    }

    get websocketEnabled() {
        // TODO: kann erst deaktiviert werden, wenn GPS-Positionsdaten nicht mehr über WebSocket gesendet werden
        return true;

        // const platform = this.getPlatform();
        // return platform != "android";
    }

    async sendeDiagnosedaten(): Promise<void> {
        log?.info('sendeDiagnosedaten');

        const fahrerListe = await AppStorage.current.get('fahrer', true, false);
        const fahrzeugeListe = await AppStorage.current.get('fahrzeuge', true, false);

        let alleAuftraege: AuftragListItem[];

        if (AppService.auftrag) {
            alleAuftraege = AppService.auftrag.alleAuftraege;
        }

        let textdatei: Textdatei = {
            typ: TextdateiTyp.Diagnosedaten,
            datum: Utils.nowIsoDateString(),
            geraeteNummer: AppConfig.current.geraeteNummer,
            AppVersion: MyApp.version,
            diagnosedaten: {
                console: {
                    logs: AppConsole.consoleLogs
                },
                appVersion: MyApp.version,
                appVersionCode: MyApp.versionCode,
                verfuegbareKlingeltoene: this.getVerfuegbareKlingeltoene().map(p => ({ name: p.Name, url: p.Url })),
                config: AppConfig.current,
                pushAvailable: this.pushAvailable.getValue(),
                pushRegistrationId: this.pushRegistrationId.getValue(),
                pushRegistrationType: this.pushRegistrationType.getValue(),
                webSocketStatus: this.webSocketStatus.getValue(),
                app: {
                    tourStartenErforderlich: MyApp.current.tourStartenErforderlich.getValue(),
                    transportauftraegeVerfuegbar: MyApp.current.transportauftraegeVerfuegbar.getValue(),
                    hofauftraegeVerfuegbar: MyApp.current.hofauftraegeVerfuegbar.getValue(),
                    nachrichtenVerfuegbar: MyApp.current.nachrichtenVerfuegbar.getValue(),
                    positionenAufzeichnen: MyApp.current.positionenAufzeichnen,
                    positionenSendenIntervall: MyApp.current.positionenSendenIntervall,
                    positionenAufzeichnenIntervall: MyApp.current.positionenAufzeichnenIntervall,
                    fahrerAngemeldet: MyApp.current.fahrerAngemeldet.getValue(),
                    tourGestartet: MyApp.current.tourGestartet.getValue(),
                    abfahrtskontrolleFertig: MyApp.current.abfahrtskontrolleFertig.getValue(),
                    fahrer: MyApp.current.fahrer.getValue(),
                    fahrzeug: MyApp.current.fahrzeug.getValue(),
                    anhaenger: MyApp.current.anhaenger.getValue(),
                    anmeldungErforderlich: MyApp.current.anmeldungErforderlich.getValue(),
                    aktuelleTour: MyApp.current.aktuelleTour.getValue(),
                    geladen: MyApp.current.geladen.getValue(),
                    alleAuftraege,
                },
                stammdaten: {
                    fahrer: fahrerListe,
                    fahrzeuge: fahrzeugeListe
                }
            }
        };

        if (MyApp.HTTP_COMPRESSION_ENABLED) {
            let json = JSON.stringify(textdatei);
            let zipped = Utils.compress(json);

            await this.remoteService.sendTextdateiZipped(zipped);
        } else {
            await this.remoteService.sendTextdateiPlain(textdatei);
        }

        // Sende für jede Log-Datei eine Diagnosedatei
        if (Logger.fileLogger && Logger.fileLoggerAktiv) {
            try {
                const logFiles = await Logger.fileLogger.getLogFiles();

                log?.debug('logFiles count: ' + logFiles.length);

                for (const logEntry of logFiles) {
                    let lines = [];

                    try {
                        const directory = FileHelper.getDirectory(logEntry.nativeURL);
                        let filename = FileHelper.getFilename(logEntry.nativeURL);

                        if (directory && filename) {
                            filename = filename.replace('%20', ' ');

                            const content = await this.file.readAsText(directory, filename);

                            if (content) {
                                lines = content.match(/[^\r\n]+/g);
                            }
                        }

                        const logTextdatei = {
                            typ: TextdateiTyp.LogDatei,
                            datum: Utils.nowIsoDateString(),
                            geraeteNummer: AppConfig.current.geraeteNummer,
                            diagnosedaten: {
                                filename,
                                fullPath: logEntry.fullPath,
                                lines,
                            }
                        };

                        if (MyApp.HTTP_COMPRESSION_ENABLED) {
                            const json = JSON.stringify(logTextdatei);
                            const zipped = Utils.compress(json);

                            await this.remoteService.sendTextdateiZipped(zipped);
                        } else {
                            await this.remoteService.sendTextdateiPlain(logTextdatei);
                        }

                    } catch (err2) {
                        log.warn('Fehler beim Lesen der Log-Dateien: ' + Utils.getErrorMessage(err2));
                    }
                }
            } catch (err) {
                log.warn('Fehler beim Lesen der Log-Dateien: ' + Utils.getErrorMessage(err));
            }
        }
    }

    private pingWebSocket(force = false) {
        if (!this.websocketEnabled) {
            return;
        }

        if (this.webSocket && this.webSocket.readyState === WebSocket.OPEN) {
            const pingIntervall = parseInt(AppConfig.current.einstellungen.WebSocketClientPingIntervall, 10);
            const reconnectTimeout = parseInt(AppConfig.current.einstellungen.WebSocketClientTimeout, 10);

            // Achtung: Die Methode pingWebSocket wird nur alle 60 Sekunden aufgerufen. Deshalb hier prüfen ob der letzte Ping 100 Sekunden her ist.
            // Das sollte somit alle 120 Sekunden einen Ping auslösen
            const timeout = Date.now() - (pingIntervall * 1000);

            if (this.lastMessageReceived < timeout || force) {
                void this.sendWebSocketMessage({ t: 1 }, 'ping');
            }

            // Der ReConnect-Timeout darf auf jeden Fall nicht im Selben Takt zuschlagen wir der Ping.
            // Wurden 4.9 Minuten (also fast 5 Minuten) lange keine Nachricht empfangen, dann erzwinge ein Reconnect
            const reconnectDate = Date.now() - (reconnectTimeout * 1000);

            if (this.lastMessageReceived < reconnectDate) {
                log.warn('Reconnecting WebSocket. lastMessageReceived zu alt: ' + this.lastMessageReceived + ", now=" + Date.now());
                this.initWebSocket('pingWebSocket 1');
            }
        } else {
            this.initWebSocket('pingWebSocket 2');
        }
    }

    public sendWebSocketMessage(obj: any, info: string): Promise<boolean> {
        log?.debug('sendWebSocketMessage: ' + info, obj);

        if (!this.websocketEnabled) {
            log?.debug('websocket disabled');
            return Promise.resolve(false);
        }

        if (!this.webSocket) {
            log?.info('sendWebSocketMessage ' + info + ': nachricht kann nicht gesendet werden. webSocket == NULL', obj);
            return Promise.resolve(false);
        }

        if (this.webSocket.readyState !== WebSocket.OPEN) {
            log?.info('sendWebSocketMessage ' + info + ': nachricht kann nicht gesendet werden. readyState=' + this.webSocket.readyState, obj);
            return Promise.resolve(false);
        }

        this.lastMessageSend = Date.now();

        const sendId = ++this.webSocketSendSeq;
        const timeoutMs = 15000;

        const resultPromise = new Promise<boolean>((resolve) => {
            const timeoutId = setTimeout(() => {
                log?.warn('sendWebSocketMessage Timeout: ' + info);
                this.finishWebSocketSend(sendId, false);
            }, timeoutMs);

            this.webSocketSendPending.set(sendId, { resolve, timeoutId });
        });

        // Pipeline asynchron starten (nicht vor dem return abwarten): sonst würde der Aufrufer erst
        // nach compressAsync/Senden zurückkehren, obwohl resultPromise bereits durch Timeout aufgelöst ist.
        void this.deliverWebSocketMessage(sendId, obj);

        return resultPromise;
    }

    /**
     * Kompression und Zustellung; läuft parallel zum Timeout in sendWebSocketMessage.
     */
    private async deliverWebSocketMessage(sendId: number, obj: any): Promise<void> {
        let wsData: string | Uint8Array;

        try {
            const json = JSON.stringify(obj);

            wsData = json;

            if (MyApp.WEBSOCKET_COMPRESSION_ENABLED && json.length > 250) {
                const zipped = await Utils.compressAsync(json);

                if (zipped?.length && json.length >= zipped.length * 1.3) {
                    // Sende die Daten komprimiert. Sie sind deutlich kleiner.
                    wsData = zipped;
                }
            }
        } catch (err) {
            log.error('deliverWebSocketMessage: Fehler beim Senden der WebSocket Nachricht (serialize): ' + Utils.getErrorMessage(err), err);
            this.finishWebSocketSend(sendId, false);
            return;
        }

        try {
            if (!this.webSocketSendPending.has(sendId)) {
                log?.debug('deliverWebSocketMessage: kein Pending (abgebrochen oder Timeout)');
                return;
            }

            let counter = 0;

            while ((!this.webSocket || this.webSocket.readyState === WebSocket.CONNECTING) && counter <= 10) {
                log?.debug('deliverWebSocketMessage delay: ' + counter);
                await Utils.delay(500);
                counter++;
            }

            if (!this.webSocketSendPending.has(sendId)) {
                // Während des Wartens auf die WebSocket-Verbindung könnte es sein, dass die Nachricht bereits abgebrochen wurde (z.B. durch einen Timeout). In diesem Fall einfach abbrechen.
                return;
            }

            if (!this.webSocket || this.webSocket.readyState !== WebSocket.OPEN) {
                log?.info('deliverWebSocketMessage: socket nicht OPEN, readyState=' + (this.webSocket ? this.webSocket.readyState : 'null'));
                this.finishWebSocketSend(sendId, false);
                return;
            }

            if (typeof wsData === 'string') {
                log?.debug('deliverWebSocketMessage: ' + wsData);
            } else {
                log?.debug('deliverWebSocketMessage: <binary ' + wsData.byteLength + ' bytes>');
            }

            this.webSocket.send(wsData);

            this.finishWebSocketSend(sendId, true);
        } catch (err) {
            log.warn('deliverWebSocketMessage: Fehler beim Senden der WebSocket Nachricht (send): ' + Utils.getErrorMessage(err), err);

            this.finishWebSocketSend(sendId, false);

            this.initWebSocket('deliverWebSocketMessage error');
        }
    }

    private verarbeiteWebSocketMessage(json: string) {
        log?.debug('verarbeiteWebSocketMessage: ' + json);

        this.lastMessageReceived = Date.now();

        try {
            const obj = JSON.parse(json) as PushMessageHeader;

            if (obj.ackId) {
                void this.sendWebSocketMessage({ t: PushMessageType.Ack, ackId: obj.ackId }, 'ACK');
            }

            switch (obj.t) {
                case PushMessageType.Ping:
                    log?.debug('PING received');
                    void this.sendWebSocketMessage({ t: 2 }, 'pong');
                    break;
                case PushMessageType.Pong:
                    log?.debug('PONG received');
                    break;
                case PushMessageType.StatusUpdate:
                    this.verarbeiteStatusUpdate(obj as StatusUpdatePushMessage);
                    break;
                case PushMessageType.DiagnosedatenAnfordern:
                    this.verarbeiteDiagnosedatenAnfordern();
                    break;
                case PushMessageType.GeraetZuruecksetzen:
                    this.verarbeiteGeraetZuruecksetzen(obj as GeraetZuruecksetzenPushMessage);
                    break;
                case PushMessageType.AuftragUpdate:
                    this.auftragUpdate.next(obj as AuftragUpdatePushMessage);
                    break;
                case PushMessageType.Hello:
                    this.sendeWebSocketLoginMessage();
                    break;

                default:
                    this.webSocketNachrichtEmpfangen.next(obj);
            }
        } catch (err) {
            log.error('Fehler beim verarbeiten der web socket nachricht', err);
        }
    }

    private verarbeiteStatusUpdate(message: StatusUpdatePushMessage) {
        log?.debug('verarbeiteStatusUpdate', message);

        if (message.a) {
            this.auftraegeAktualisieren.next();
        }

        if (message.s) {
            this.stammdatenAktualisieren.next();
        }

        if (message.e) {
            this.einstellungenAktualisieren.next();
        }

        if (message.d) {
            this.fahrerAktualisieren.next();
        }

        if (message.f) {
            this.fahrzeugeAktualisieren.next();
        }

        if (message.uvv) {
            this.uvvAktualisieren.next();
        }

        if (message.n) {
            this.nachrichtenAktualisieren.next();
        }

        if (message.tour) {
            this.tourenAktualisieren.next();
        }

        if (message.changelog) {
            this.changelogAktualisieren.next();
        }

        if (message.texte) {
            this.texteAktualisieren.next();
        }
    }

    private async sendeGeoPositionen() {
        log?.debug('sendeGeoPositionen');

        // TODO CAPACITOR: BackgroundGeolocation umbauen auf neues Plugin. siehe: https://github.com/capacitor-community/background-geolocation?tab=readme-ov-file

        const backgroundGeolocation = this.backgroundGeolocation;

        if (!MyApp.isCordovaAvailable()) {
            log.warn('Cordova nicht verfügbar. Aktuelle GPS-Position kann nicht gesendet werden');
            return;
        }

        if (!backgroundGeolocation) {
            log.warn('backgroundGeolocation nicht verfügbar');
            return;
        }

        const intervall = MyApp.current.positionenSendenIntervall;

        if (intervall <= 0) {
            // Positionen sollen nicht gesendet werden
            backgroundGeolocation.deleteAllLocations();
            return;
        }

        try {
            const geoPositionen = await backgroundGeolocation.getValidLocations();

            log?.debug('geoPositionen length: ' + geoPositionen.length);

            if (!geoPositionen.length) {
                return;
            }

            this.geoPositionenGesendet = Date.now();

            let batchSize = 100;

            while (geoPositionen.length > 0) {
                let subList = geoPositionen.splice(0, batchSize);

                log?.debug('Sende GPS-Positionen: ' + subList.length);

                const gpsPositionen: GpsPositionPush[] = [];

                const roundFaktor = 1000000;

                for (const p of subList) {
                    gpsPositionen.push({
                        a: Math.round(p.latitude * roundFaktor) / roundFaktor,
                        b: Math.round(p.longitude * roundFaktor) / roundFaktor,
                        s: p.time,
                        u: p.accuracy,
                        v: p.speed,
                        w: p.bearing,
                        // p: p.provider
                    });
                }

                const textdatei: Textdatei = {
                    typ: TextdateiTyp.Positionen,
                    datum: Utils.nowIsoDateString(),
                    geraeteNummer: AppConfig.current.geraeteNummer,
                    GpsPositionen: gpsPositionen
                };

                await this.sendeTextdatei(textdatei, false);
            }

            await backgroundGeolocation.deleteAllLocations();
        } catch (err) {
            log.error('Fehler beim Senden der GPS-Positionen: ' + Utils.getErrorMessage(err));
            return;
        }
    }

    private async checkGeolocationService() {
        if (!MyApp.isCordovaAvailable()) {
            return;
        }

        // TODO CAPACITOR: BackgroundGeolocation umbauen auf neues Plugin. siehe: https://github.com/capacitor-community/background-geolocation?tab=readme-ov-file

        const backgroundGeolocation = this.backgroundGeolocation;

        if (!MyApp.current.positionenAufzeichnen) {
            return;
        }

        if (this.checkGeolocationStatusLaeuft) {
            return;
        }

        try {
            this.checkGeolocationStatusLaeuft = true;

            const status = await backgroundGeolocation.checkStatus();

            if (!status.isRunning) {
                log?.debug('backgroundGeolocation service not running. starting...');
                backgroundGeolocation.start();
                this.geolocationserviceLetzterRestart = Date.now();
                return;
            }

            // Prüfe ob der Background-Geolocation-Dienst neu gestartet werden muss.
            // Das ist notwendig, wenn er für eine längere Zeit keine Positionen geliefert hat.
            const ZEHN_MINUTEN_MS = 10 * 60 * 1000;

            // Positionen werden normalerweise alle 30 - 60 Sekunden aufzeichnet.
            // Wenn 10 * 30 Sekunden = 5 Minuten vergangen sind, ohne dass eine Position empfangen wurde, dann ist das schon ungewöhnlich.
            // Es soll dann der Dienst neu gestartet werden.
            const timeout = 10 * (MyApp.current.positionenAufzeichnenIntervall * 1000);

            let restartErforderlich = this.letzteGeoLocationEmpfangen < (Date.now() - timeout)
                && this.geolocationserviceLetzterRestart < (Date.now() - ZEHN_MINUTEN_MS);

            if (restartErforderlich) {
                this.geolocationserviceLetzterRestart = Date.now();

                log?.warn(`backgroundGeolocation: seit ${Math.round(timeout / 1000)}s keine Position. Starte Dienst neu...`);

                try {
                    await backgroundGeolocation.stop();
                } catch (err) {
                    log?.warn('backgroundGeolocation restart stop(): ' + Utils.getErrorMessage(err, true));
                }

                await Utils.delay(1500);

                try {
                    await backgroundGeolocation.start();
                } catch (err) {
                    log?.warn('backgroundGeolocation restart start(): ' + Utils.getErrorMessage(err, true));
                }
            }
        } catch (err) {
            log.error('checkGeolocationService: ' + Utils.getErrorMessage(err));
        } finally {
            this.checkGeolocationStatusLaeuft = false;
        }
    }

    /**
     * Der Server fordert das Zurücksetzen der App an (Fernlöschung durch einen Sysadmin).
     * Es wird geprüft, ob der Befehl wirklich für die aktuell konfigurierte Geräte-Nummer gilt:
     * Eine verspätet zugestellte Nachricht darf ein zwischenzeitlich neu konfiguriertes Gerät nicht löschen.
     */
    private verarbeiteGeraetZuruecksetzen(message: GeraetZuruecksetzenPushMessage) {
        log.warn('verarbeiteGeraetZuruecksetzen', message);

        const mandant = (message?.Mandant || '').trim().toUpperCase();
        const geraeteNummer = (message?.GeraeteNummer || '').trim().toUpperCase();

        const aktuellerMandant = (AppConfig.current.mandant || '').trim().toUpperCase();
        const aktuelleGeraeteNummer = (AppConfig.current.geraeteNummer || '').trim().toUpperCase();

        if (!mandant || !geraeteNummer) {
            log.warn('verarbeiteGeraetZuruecksetzen: Mandant oder Geräte-Nummer fehlt in der Nachricht. Abbruch.');
            return;
        }

        if (mandant !== aktuellerMandant || geraeteNummer !== aktuelleGeraeteNummer) {
            log.warn(`verarbeiteGeraetZuruecksetzen: Die Nachricht gilt für ${mandant}/${geraeteNummer},`
                + ` konfiguriert ist aber ${aktuellerMandant}/${aktuelleGeraeteNummer}. Abbruch.`);
            return;
        }

        this.geraetZuruecksetzenAngefordert.next();
    }

    private verarbeiteDiagnosedatenAnfordern() {
        log?.info('verarbeiteDiagnosedatenAnfordern');

        try {
            this.sendeDiagnosedaten();
        } catch (err) {
            log.error('verarbeiteDiagnosedatenAnfordern', err);
        }
    }

    /**
     * Returns if we are connected to the server
     */
    isConnectedToServer(): boolean {
        return this.webSocketConnected.getValue();
    }

    isInternetAvailable(): boolean {
        return MyApp.internetAvailable.getValue();
    }

    /**
     * Diese Methode wird alle 60 Sekunden aufgerufen
     */
    update(info: string) {
        log?.debug('update: ' + info);

        try {
            if (!MyApp.internetAvailable.getValue()) {
                if (this.webSocketConnected.getValue()) {
                    MyApp.internetAvailable.next(true);
                }
            }
        } catch (err) {
            log.error('sendePostausgang', err);
        }

        try {
            if (MyApp.internetAvailable.getValue()) {
                this.sendePostausgang();
            }
        } catch (err) {
            log.error('sendePostausgang', err);
        }

        try {
            this.updateAnzahlPostausgangNachrichten();
        } catch (err) {
            log.error('sendePostausgang', err);
        }

        try {
            if (this.websocketEnabled) {
                this.pingWebSocket();
            }
        } catch (err) {
            log.error('pingWebSocket', err);
        }

        try {
            this.checkGeolocationService();
        } catch (err) {
            log.error('update checkGeolocationService', err);
        }

        try {
            this.downloadQueuedFiles();
        } catch (err) {
            log.error('update downloadQueuedFiles', err);
        }

        try {
            if (AppConfig.current.einstellungen.AppUpdateAktiv === 'ja') {
                // Alle 12 Stunden auf ein Update prüfen
                if (this.lastUpdateCheck < Date.now() - 12 * 60 * 60 * 1000) {
                    if (this.istImVordergrund.getValue() && this.isInternetAvailable()) {
                        this.lastUpdateCheck = Date.now();
                        this.checkUpdate(false);
                    }
                }
            }
        } catch (err) {
            log.error('update update check', err);
        }

        this.aktualisiereEinstellungenWennNotwendig();
    }

    async enqueueDownloadFiles(downloadFileList: DownloadFile[]) {
        log?.info('enqueueDownloadFiles', downloadFileList);

        if (!this.filedownloadQueue) {
            this.filedownloadQueue = [];
        }

        if (!downloadFileList?.length) {
            return;
        }

        for (const file of downloadFileList) {
            if (this.filedownloadQueue.find(p => p.guid == file.guid && p.filePath == file.filePath)) {
                // wird schon heruntergeladen...
                log?.debug('Datei wird schon heruntergeladen', file);
                continue;
            }

            this.filedownloadQueue.push(file);
        }

        await AppStorage.current.set('download-file-queue', this.filedownloadQueue);

        setTimeout(() => this.downloadQueuedFiles(), 500);
    }

    async downloadFile(downloadFile: DownloadFile): Promise<DownloadFileResult> {
        log?.info("downloadFile: " + downloadFile.filePath, downloadFile);

        if (!MyApp.isCordovaAvailable()) {
            log.warn('Cordova nicht verfügbar. Datei-Download nicht möglich');
            return;
        }

        try {
            const url = this.remoteService.toAbsoluteUrl('/api/app/file/' + downloadFile.guid);

            // Extract just the filename. Result example: cdv_photo_003.jpg
            // const tempFilename = FileHelper.getFilename(downloadFile.filePath);

            let directory = downloadFile.directory;

            if (!directory) {
                // Hier wird "DATA" oder so zurückgegeben.
                directory = MyApp.getDownloadDirectory();
            }

            // Absolute Pfade müssen in relative PFade konvertiert werden.
            // Das hat sich leider bei der Migration von cordova nach capacitor geändert.
            let filePath = downloadFile.filePath;

            if (filePath.startsWith('file:///data/')) {
                // suchde die APP-ID im Pfad.
                // let idx = filePath.indexOf(MyApp.packageName);

                // if (idx > 0) {
                //     // Schneide alles nach der App-ID weg, inkl. dem Slash am Ende
                //     filePath = filePath.substring(idx + MyApp.packageName.length + 1);
                // }

                const directoryAndPath = FileHelper.getDirectoryAndPath(filePath);

                directory = directoryAndPath.directory;
                filePath = directoryAndPath.path;
            }

            log?.debug('downloadFile filePath: ' + filePath);

            let idx = filePath.lastIndexOf('/');
            let dirPath = '';

            if (idx >= 0) {
                dirPath = filePath.substr(0, idx);
            }

            if (dirPath) {
                await FileHelper.mkdir(directory, dirPath);
            }

            const downloadResult = await this.remoteService.downloadFile(url, directory, filePath);

            if (downloadResult.errorMessage) {
                throw new Error(downloadResult.errorMessage);
            }

            log?.info('downloadResult: ' + downloadResult.path);

            return downloadResult;

        } catch (err) {
            log.error('downloadFile: ' + Utils.getErrorMessage(err), err);
            throw err;
        }
    }

    async downloadQueuedFiles() {
        if (this.downloadRunning) {
            return;
        }

        if (!this.filedownloadQueue || !this.filedownloadQueue.length) {
            return;
        }

        if (!this.isInternetAvailable()) {
            return;
        }

        this.downloadRunning = true;

        if (this.filedownloadQueue.length > 0) {
            const downloadFile = this.filedownloadQueue.pop();

            try {
                const directoryAndPath = FileHelper.getDirectoryAndPath(downloadFile.filePath);

                const directory = directoryAndPath.directory;
                const path = directoryAndPath.path;

                const fileExists = await FileHelper.checkFileExists(directory, path);

                if (!fileExists) {
                    const downloadResult = await this.downloadFile(downloadFile);

                    log?.debug('Datei heruntergeladen: ' + downloadResult.path);

                    log?.info("Download erfolgreich: " + downloadFile.filePath);
                } else {
                    log?.info("Datei existiert bereits. Downlaod nicht notwendig: " + downloadFile.filePath);
                }

                await AppStorage.current.set('download-file-queue', this.filedownloadQueue);

                // Nächste Datei herunterladen
                setTimeout(() => this.downloadQueuedFiles(), 100);
            } catch (err: any) {
                log.warn("Download fehlgeschlagen " + downloadFile.filename + ': ' + JSON.stringify(err));

                downloadFile.errorCount++;

                if (err.http_status) {
                    const httpStatus = err.http_status as number;

                    if (httpStatus == 404) {
                        // Datei ist auf dem Server nicht vorhanden. Nicht nochmal probieren
                        downloadFile.errorCount = 1000;
                    }
                }

                if (downloadFile.errorCount < 3) {
                    // Wieder zur Download-Liste hinzufügen.
                    this.filedownloadQueue.push(downloadFile);
                }

                await AppStorage.current.set('download-file-queue', this.filedownloadQueue);

                // Nicht direkt weitere Dateien herunterladen. Warte auf den "update" alle 60 Sekunden.
                // setTimeout(() => this.downloadQueuedFiles(), 5000);
            }
        }

        this.downloadRunning = false;
    }

    anrufenTelefonnummer(telNummer: string) {
        log?.info('anrufenTelefonnummer: ' + telNummer);

        if (!telNummer) {
            return;
        }

        telNummer = Utils.normalisiereTelefonnummer(telNummer);

        const link = document.createElement("a");
        link.href = "tel:" + telNummer;
        link.click();
    }

    async requestGeolocationPermissions(): Promise<void> {
        await this.requestPermissions(
            'android.permission.ACCESS_BACKGROUND_LOCATION',
            'android.permission.ACCESS_FINE_LOCATION',
            'android.permission.REQUEST_IGNORE_BATTERY_OPTIMIZATIONS',
            // 'android.permission.ACCESS_MEDIA_LOCATION',
            // 'android.permission.WRITE_EXTERNAL_STORAGE'
        );
    }

    async requestPermissions(...permissions: string[]): Promise<void> {
        if (!MyApp.isCordovaAvailable()) {
            log.warn("requestPermissions: Cordova nicht verfügbar.")
            return;
        }

        for (const permission of permissions) {
            let hasPermission = false;

            if (!permission) {
                log.warn(`Unbekannte Permission '${permission}' in array: ` + permissions.join(', '));
                continue;
            }

            try {
                const result = await AndroidPermissions.checkPermission(permission);
                hasPermission = result.hasPermission;

                log?.info('checkPermission ' + permission + ': ' + hasPermission);
            } catch (err) {
                log.error('checkPermission ' + permission + ': ' + Utils.getErrorMessage(err, true));
                hasPermission = false;
            }

            if (!hasPermission) {
                try {
                    log?.info('Requesting permission: ' + permission);

                    const result = await AndroidPermissions.requestPermission(permission);

                    log?.info('requestPermission ' + permission + ': ' + result.hasPermission);
                } catch (err) {
                    log.error('requestPermission ' + permission + ': ' + Utils.getErrorMessage(err, true));
                }
            }
        }
    }

    // async startBackgroundGeolocationCapacitor() {
    //     log?.info('startBackgroundGeolocation: Capacitor');

    //     await this.requestGeolocationPermissions();

    //     try {
    //         if (!MyApp.isCordovaAvailable()) {
    //             log.warn('Cordova nicht verfügbar: Background Geolocation wird nicht aktiviert');
    //             return;
    //         }

    //         await MyApp.ready();

    //         log?.info('startBackgroundGeolocation app ready');

    //         // Etwas warten bis der Geolocation-Service aktiviert wird.
    //         // Es sollen erst andere Einstellungen geladen werden
    //         await Utils.delay(5000);

    //         log?.info('startBackgroundGeolocation delay finished');

    //         // see: https://github.com/capacitor-community/background-geolocation?tab=readme-ov-file

    //         // To start listening for changes in the device's location, add a new watcher.
    //         // You do this by calling 'addWatcher' with an options object and a callback. A
    //         // Promise is returned, which resolves to the callback ID used to remove the
    //         // watcher in the future. The callback will be called every time a new location
    //         // is available. Watchers can not be paused, only removed. Multiple watchers may
    //         // exist simultaneously.
    //         const watcherOptions: WatcherOptions = {
    //             // If the "backgroundMessage" option is defined, the watcher will
    //             // provide location updates whether the app is in the background or the
    //             // foreground. If it is not defined, location updates are only
    //             // guaranteed in the foreground. This is true on both platforms.

    //             // On Android, a notification must be shown to continue receiving
    //             // location updates in the background. This option specifies the text of
    //             // that notification.
    //             backgroundMessage: "GPS-Dienst ist aktiv",

    //             // The title of the notification mentioned above. Defaults to "Using
    //             // your location".
    //             backgroundTitle: "ReCoMobil GPS-Dienst",

    //             // Whether permissions should be requested from the user automatically,
    //             // if they are not already granted. Defaults to "true".
    //             requestPermissions: true,

    //             // If "true", stale locations may be delivered while the device
    //             // obtains a GPS fix. You are responsible for checking the "time"
    //             // property. If "false", locations are guaranteed to be up to date.
    //             // Defaults to "false".
    //             stale: false,

    //             // The minimum number of metres between subsequent locations. Defaults
    //             // to 0.
    //             distanceFilter: MyApp.current.PositionenDistanceFilter
    //         };

    //         const callback = (location: Location, error?: CallbackError) => {
    //             if (error) {
    //                 if (error.code === "NOT_AUTHORIZED") {
    //                     if (window.confirm(
    //                         "This app needs your location, " +
    //                         "but does not have permission.\n\n" +
    //                         "Open settings now?"
    //                     )) {
    //                         // It can be useful to direct the user to their device's
    //                         // settings when location permissions have been denied. The
    //                         // plugin provides the 'openSettings' method to do exactly
    //                         // this.
    //                         BackgroundGeolocation.openSettings();
    //                     }
    //                 }

    //                 return console.error(error);
    //             }

    //             return console.log(location);
    //         }

    //         this.gpsWatcherId = await BackgroundGeolocation.addWatcher(watcherOptions, callback);

    //         MyApp.current.configRefreshed.subscribe(p => {
    //             this.updatePositionenSendenInterval();
    //         });

    //         this.updatePositionenSendenInterval();

    //         log?.debug('startBackgroundGeolocation done');
    //     } catch (err) {
    //         log.error('startBackgroundGeolocation', err);
    //     }
    // }

    // stopBackgroundGeolocation() {
    //     log?.info('stopBackgroundGeolocation: ' + this.gpsWatcherId);

    //     try {
    //         if (this.gpsWatcherId) {
    //             // When a watcher is no longer needed, it should be removed by calling
    //             // 'removeWatcher' with an object containing its ID.
    //             BackgroundGeolocation.removeWatcher({
    //                 id: this.gpsWatcherId
    //             });

    //             this.gpsWatcherId = null;
    //         }
    //     } catch (err) {
    //         log.error('stopBackgroundGeolocation: ' + Utils.getErrorMessage(err), err);
    //     }
    // }

    async startBackgroundGeolocation() {
        log?.info('startBackgroundGeolocation');

        await this.requestGeolocationPermissions();

        try {
            if (!MyApp.isCordovaAvailable()) {
                log.warn('Cordova nicht verfügbar: Background Geolocation wird nicht aktiviert');
                return;
            }

            await MyApp.ready();

            log?.info('startBackgroundGeolocation app ready');

            // Etwas warten bis der Geolocation-Service aktiviert wird.
            // Es sollen erst andere Einstellungen geladen werden
            await Utils.delay(5000);

            log?.info('startBackgroundGeolocation delay finished');

            // TODO CAPACITOR: BackgroundGeolocation umbauen auf neues Plugin. siehe: https://github.com/capacitor-community/background-geolocation?tab=readme-ov-file

            const backgroundGeolocation = this.backgroundGeolocation;

            const config: BackgroundGeolocationConfig = {
                locationProvider: this.getLocationProvider(),

                // Desired accuracy in meters. Possible values [HIGH_ACCURACY, MEDIUM_ACCURACY, LOW_ACCURACY, PASSIVE_ACCURACY].
                // Accuracy has direct effect on power drain. Lower accuracy = lower power drain.
                desiredAccuracy: MyApp.current.PositionenDesiredAccuracy,

                // Stationary radius in meters. When stopped, the minimum distance the device must move beyond the stationary
                // location for aggressive background-tracking to engage.
                stationaryRadius: MyApp.current.PositionenStationaryRadius,

                // The minimum distance (measured in meters) a device must move horizontally before an update event is generated. @see Apple docs.
                distanceFilter: MyApp.current.PositionenDistanceFilter,

                notificationTitle: 'ReCoMobil GPS-Dienst',
                notificationText: 'GPS-Dienst ist aktiv',

                // When enabled, the plugin will emit sounds for life-cycle events of background-geolocation! See debugging sounds table.
                debug: MyApp.current.PositionenDebugAktiv,

                // The minimum time interval between location updates in milliseconds. @see Android docs for more information.
                interval: MyApp.current.positionenAufzeichnenIntervall * 1000,

                // Fastest rate in milliseconds at which your app can handle location updates. @see Android docs.
                fastestInterval: MyApp.current.positionenAufzeichnenIntervall * 1000 / 2,

                // Rate in milliseconds at which activity recognition occurs. Larger values will result in fewer activity detections while improving battery life.
                activitiesInterval: MyApp.current.PositionenActivitiesInterval * 1000,

                // Enable this in order to force a stop() when the application terminated (e.g. on iOS, double-tap home button, swipe away the app).
                stopOnTerminate: !MyApp.current.PositionenAufzeichnenAktivHalten,

                // Limit maximum number of locations stored into db
                maxLocations: 10000,
            };

            log?.info('startBackgroundGeolocation configuration: ' + JSON.stringify(config));

            backgroundGeolocation.configure(config);

            backgroundGeolocation.on(BackgroundGeolocationEvents.error).subscribe((error) => {
                log.warn('backgroundGeolocation error: ' + Utils.getErrorMessage(error, true));
            });

            backgroundGeolocation.on(BackgroundGeolocationEvents.start).subscribe(() => {
                log?.debug('backgroundGeolocation start');
            });

            backgroundGeolocation.on(BackgroundGeolocationEvents.stop).subscribe(() => {
                log?.debug('backgroundGeolocation stop');
            });

            backgroundGeolocation.on(BackgroundGeolocationEvents.background).subscribe(() => {
                log?.debug('backgroundGeolocation background');
            });

            backgroundGeolocation.on(BackgroundGeolocationEvents.foreground).subscribe(() => {
                log?.debug('backgroundGeolocation foreground');
            });


            backgroundGeolocation.on(BackgroundGeolocationEvents.location).subscribe((gpsLocation: GpsLocation) => {
                if (Logger.globalLogLevel <= LogLevel.DEBUG) {
                    log?.debug(`backgroundGeolocation location: lat=${gpsLocation.latitude}, lon=${gpsLocation.longitude}, t=${gpsLocation.time}, acc=${gpsLocation.accuracy}, provider=${gpsLocation.provider}`);
                }

                this.letzteGeoLocationEmpfangen = Date.now();

                // handle your locations here
                // to perform long running operation on iOS
                // you need to create background task
                // backgroundGeolocation.startTask((taskKey) => {
                //     log?.debug('backgroundGeolocation startTask', taskKey);

                //     // execute long running task
                //     // eg. ajax post location
                //     // IMPORTANT: task has to be ended by endTask
                //     backgroundGeolocation.endTask(taskKey);
                // });
            });

            if (Logger.globalLogLevel <= LogLevel.DEBUG) {
                backgroundGeolocation.on(BackgroundGeolocationEvents.stationary).subscribe((gpsLocation) => {
                    log?.debug(`backgroundGeolocation stationary`);
                });

                backgroundGeolocation.on(BackgroundGeolocationEvents.abort_requested).subscribe(() => {
                    log?.debug('backgroundGeolocation abort_requested');
                });

                backgroundGeolocation.on(BackgroundGeolocationEvents.http_authorization).subscribe(() => {
                    log?.debug('backgroundGeolocation http_authorization');
                });
            }

            backgroundGeolocation.on(BackgroundGeolocationEvents.authorization).subscribe((status) => {
                log?.debug('backgroundGeolocation authorization', status);

                // TODO CAPACITOR. status prüfen
                // if (status !== BackgroundGeolocationAuthorizationStatus.AUTHORIZED) {
                //     // we need to set delay or otherwise alert may not be shown
                //     setTimeout(() => {
                //         try {
                //             const showSettings = confirm('ReCoMobil benötigt Zugriff auf GPS-Koordinaten. Einstellungen jetzt öffnen?');
                //             if (showSettings) {
                //                 return backgroundGeolocation.showAppSettings();
                //             }
                //         } catch (err) {
                //             log.error('setTimeout authorization: ' + Utils.getErrorMessage(err), err);
                //         }
                //     }, 1000);
                // }
            });

            MyApp.current.configRefreshed.subscribe(p => {
                const aktiv = MyApp.current.positionenAufzeichnen;

                if (aktiv != this.positionenAufzeichnenAktiv) {
                    if (aktiv) {
                        log?.debug('Background geolocation start');

                        const newConfig: BackgroundGeolocationConfig = {
                            locationProvider: this.getLocationProvider(),
                            desiredAccuracy: MyApp.current.PositionenDesiredAccuracy,
                            stationaryRadius: MyApp.current.PositionenStationaryRadius,
                            distanceFilter: MyApp.current.PositionenDistanceFilter,
                            debug: MyApp.current.PositionenDebugAktiv,
                            interval: MyApp.current.positionenAufzeichnenIntervall * 1000,
                            fastestInterval: MyApp.current.positionenAufzeichnenIntervall * 1000 / 2,
                            activitiesInterval: MyApp.current.PositionenActivitiesInterval * 1000,
                            stopOnTerminate: !MyApp.current.PositionenAufzeichnenAktivHalten
                        };

                        log?.info('startBackgroundGeolocation update configuration: ' + JSON.stringify(newConfig));

                        // Konfiguration aktualisieren
                        backgroundGeolocation.configure(newConfig);

                        backgroundGeolocation.start();

                        this.geolocationserviceLetzterRestart = Date.now();
                    } else {
                        log?.debug('Background geolocation stop');
                        backgroundGeolocation.stop();
                    }
                }

                this.updatePositionenSendenInterval();
            });

            this.updatePositionenSendenInterval();

            log?.debug('startBackgroundGeolocation done');
        } catch (err) {
            log.error('startBackgroundGeolocation', err);
        }
    }

    updatePositionenSendenInterval() {
        if (this.positionenSendenIntervalId) {
            clearInterval(this.positionenSendenIntervalId);
            this.positionenSendenIntervalId = null;
        }

        if (MyApp.current.positionenAufzeichnen) {
            const intervall = MyApp.current.positionenSendenIntervall * 1000;

            if (intervall > 0) {
                this.positionenSendenIntervalId = setInterval(() => {
                    try {
                        this.sendeGeoPositionen();
                    } catch (err) {
                        log.error('update sendeGeoPositionen', err);
                    }
                }, intervall);
            }
        }
    }

    private getLocationProvider() {
        let locationProvider;

        if (AppConfig.current.einstellungen.PositionenLocationProvider == 'DISTANCE_FILTER_PROVIDER') {
            locationProvider = BackgroundGeolocationLocationProvider.DISTANCE_FILTER_PROVIDER;
        } else if (AppConfig.current.einstellungen.PositionenLocationProvider == 'ACTIVITY_PROVIDER') {
            locationProvider = BackgroundGeolocationLocationProvider.ACTIVITY_PROVIDER;
        } else {
            locationProvider = BackgroundGeolocationLocationProvider.RAW_PROVIDER;
        }

        return locationProvider;
    }

    async checkUpdate(meldungenAnzeigen = false, force = false): Promise<boolean> {
        log?.debug('checkUpdate');

        if (!MyApp.isAndroid()) {
            if (meldungenAnzeigen) {
                UiHelper.showAlert('Update nur unter Android verfügbar');
            } else {
                log?.debug('Update nur unter Android verfügbar.');
            }

            return false;
        }

        try {
            // const installedVersion = await ApkUpdaterPlugin.getInstalledVersion();

            // log?.info('installedVersion: ' + JSON.stringify(installedVersion));

            const result = await this.remoteService.checkUpdate();

            if (!result) {
                if (meldungenAnzeigen) {
                    UiHelper.showFehlerKommunikation();
                }

                return false;
            }

            if (result.Version <= MyApp.versionCode) {
                log?.info('Kein Update erforderlich');

                if (meldungenAnzeigen) {
                    UiHelper.showAlert('Kein Update verfügbar. Aktuellste Version ist installiert.');
                }

                return false;
            }

            if (meldungenAnzeigen) {
                MyApp.loading(true);
            }

            const downloadResult = await ApkUpdaterPlugin.download({
                url: result.Url
            });

            log?.info('downloadResult: ' + JSON.stringify(downloadResult));

            if (meldungenAnzeigen) {
                MyApp.loading(false);
            }

            if (downloadResult.success) {
                const installResult = await ApkUpdaterPlugin.install();

                log?.info('installResult: ' + JSON.stringify(installResult));
            }
        } catch (err) {
            MyApp.loading(false);

            log.error('checkUpdate: ' + Utils.getErrorMessage(err));

            if (meldungenAnzeigen) {
                UiHelper.showError(err);
            }

            return false;
        }
    }

    async starteNavigation(adresse: Adresse): Promise<boolean> {
        log?.debug('starteNavigation', adresse);

        const navigationsApp = AppConfig.current.einstellungen.NavigationsApp;

        // if (navigationsApp == 'PTV') {
        //     return await this.starteNavigationPTV(adresse);
        // }

        const appConfig = AppConfig.current;

        const options: LaunchNavigatorOptions = {
            appSelection: {
                rememberChoice: {
                    promptFn: (callback: (rememberChoice: boolean) => void) => {
                        UiHelper.confirmJaNein('Navigations-App merken?').then(antwort => {
                            callback(antwort);
                        });
                    },
                    enabled: 'prompt'
                }
            },
            enableGeocoding: appConfig.einstellungen.NavigationGeocodingErlauben !== 'nein',

            // Aktuelle Position abfragen (als Start?)
            // enableGeolocation: appConfig.einstellungen.NavigationGeocodingErlauben !== 'nein',
        };

        if (!this.launchNavigator.isAvailable()) {
            UiHelper.showErrorOhneSentry('Navigation nicht verfügbar');
            return;
        }

        if (navigationsApp) {
            switch (navigationsApp) {
                case 'user_select':
                    options.app = this.launchNavigator.APP.USER_SELECT;
                    break;
                case 'geo':
                    options.app = this.launchNavigator.APP.GEO;
                    break;
                case 'PTV':
                    options.app = this.launchNavigator.APP.GEO;
                    break;
                case 'apple_maps':
                    options.app = this.launchNavigator.APP.APPLE_MAPS;
                    break;
                case 'google_maps':
                    options.app = this.launchNavigator.APP.GOOGLE_MAPS;
                    break;
                case 'waze':
                    options.app = this.launchNavigator.APP.WAZE;
                    break;
                case 'citymapper':
                    options.app = this.launchNavigator.APP.CITYMAPPER;
                    break;
                case 'navigon':
                    options.app = this.launchNavigator.APP.NAVIGON;
                    break;
                case 'transit_app':
                    options.app = this.launchNavigator.APP.TRANSIT_APP;
                    break;
                case 'yandex':
                    options.app = this.launchNavigator.APP.YANDEX;
                    break;
                case 'uber':
                    options.app = this.launchNavigator.APP.UBER;
                    break;
                case 'tomtom':
                    options.app = this.launchNavigator.APP.TOMTOM;
                    break;
                case 'bing_maps':
                    options.app = this.launchNavigator.APP.BING_MAPS;
                    break;
                case 'sygic':
                    options.app = this.launchNavigator.APP.SYGIC;
                    break;
                case 'here_maps':
                    options.app = this.launchNavigator.APP.HERE_MAPS;
                    break;
                case 'moovit':
                    options.app = this.launchNavigator.APP.MOOVIT;
                    break;
                case 'lyft':
                    options.app = this.launchNavigator.APP.LYFT;
                    break;
                default:
                    options.app = navigationsApp;
                    break;
            }

            if (options.app && options.app != 'geo' && options.app != this.launchNavigator.APP.USER_SELECT) {
                const verfuegbar = await this.launchNavigator.isAppAvailable(options.app);

                if (!verfuegbar) {
                    options.app = this.launchNavigator.APP.USER_SELECT;
                }
            }
        } else {
            // Das darf nicht gesetzt werden. Ansonsten merkt sich die Anwendung nicht die Einstellung
            // options.app = this.launchNavigator.APP.USER_SELECT;
        }

        let destination: string | number[] = adresse.Strasse + ', ' + adresse.PLZ + ' ' + adresse.Ort;

        options.destinationName = adresse.Name1 + ', ' + destination;

        const strasseHausnr = this.getStrasseHausnummer(adresse.Strasse);

        // Daten extra für PTV Navigator übergeben.
        options.plz = adresse.PLZ;
        options.ort = adresse.Ort;
        options.lkz = adresse.LKZ;
        options.hausnummer = strasseHausnr.hausnummer;
        options.strasse = strasseHausnr.strasse;
        options.latitude = adresse.GeoY;
        options.longitude = adresse.GeoX;
        options.geoKoordinatenBevorzugen = AppConfig.current.einstellungen.NavigationGeoKoordinatenBevorzugen;

        // Navigatio ndirekt starten 
        // options.launchModeGoogleMaps = 'turn-by-turn';

        if (AppConfig.current.einstellungen.NavigationGeoKoordinatenBevorzugen === 'ja') {
            if (adresse.GeoX && adresse.GeoY) {
                destination = this.getDestinationLatLong(adresse, navigationsApp);
            } else if (adresse.Strasse && adresse.PLZ && adresse.Ort) {
                destination = this.getDestinationAdresse(adresse, navigationsApp);
            }
        } else {
            if (adresse.Strasse && adresse.PLZ && adresse.Ort) {
                destination = this.getDestinationAdresse(adresse, navigationsApp);
            } else if (adresse.GeoX && adresse.GeoY) {
                destination = this.getDestinationLatLong(adresse, navigationsApp);
            }
        }

        try {
            log?.debug('starteNavigation: ' + destination);

            if (AppConfig.current.einstellungen.NavigationAbAktuellerPosition === 'ja') {
                MyApp.loading(true);

                const startPosition = await this.getAktuelleGpsPosition('starteNavigation', 30);

                if (startPosition) {
                    options.start = [startPosition.Latitude, startPosition.Longitude];
                    options.startName = 'Aktuelle Position';
                }
            }

            // Geocoding nur erlauben, wenn auch eine Google API-Key konfiguriert ist. Ansonsten funktioniert das sowieso nicht.
            const googleApiKey = AppConfig.current.einstellungen.GoogleApiKey;

            if (!googleApiKey) {
                options.enableGeocoding = false;
            }

            // this.launchNavigator.setApiKey('AIzaSyB8R5hx7aJXGJMZvIF2rZu-QkTOccvNjB8');

            if (typeof (destination) === 'string') {
                if (typeof (destination) === 'string' && destination.startsWith("geo:")) {
                    const link = document.createElement("a");
                    link.href = destination; // "geo:0,0?q=DE,76131,Karlsruhe,Haid,15";
                    link.click();
                } else {
                    await this.launchNavigator.navigate(destination, options);
                }
            } else {
                await this.launchNavigator.navigate(destination, options);
            }

            log.info('Navigation gestartet: ' + destination + ', app: ' + options.app);

            // log?.info('Launched navigator result', result);
        } catch (err) {
            log.error('launchNavigator: ' + Utils.getErrorMessage(err), err);

            UiHelper.showError(err);
        }

        MyApp.loading(false);

        log?.debug('starteNavigation done');

        return true;
    }

    getDestinationAdresse(adresse: Adresse, navigationsApp: string): string {
        switch (navigationsApp) {
            case 'PTV':
                let land = adresse.LKZ;

                if (!land) {
                    land = 'DE';
                }

                const strasseHausnr = this.getStrasseHausnummer(adresse.Strasse);

                if (strasseHausnr.hausnummer) {
                    return `geo:0,0?q=${land},${adresse.PLZ},${adresse.Ort},${strasseHausnr.strasse},${strasseHausnr.hausnummer}`;
                } else {
                    return `geo:0,0?q=${land},${adresse.PLZ},${adresse.Ort},${adresse.Strasse}`;
                }

            default:
                return adresse.Strasse + ', ' + adresse.PLZ + ' ' + adresse.Ort;
        }
    }

    getDestinationLatLong(adresse: Adresse, navigationsApp: string): string | number[] {
        switch (navigationsApp) {
            case 'PTV':
                return `geo:0,0?q=${adresse.GeoY},${adresse.GeoX}`;

            default:
                return [adresse.GeoY, adresse.GeoX];
        }
    }

    getStrasseHausnummer(str: string): { strasse: string, hausnummer: string } {
        if (str) {
            str = str.replace(/[\.\,/\\?%*:|"<>]/g, '');

            let pos = -1;

            for (let i = 0; i < str.length; i++) {
                const c = str[i];

                if (c >= '0' && c <= '9') {
                    pos = i;
                    break;
                }
            }

            if (pos > 0) {
                return {
                    strasse: str.substring(0, pos).trim(),
                    hausnummer: str.substr(pos).trim()
                };
            } else {
                return {
                    strasse: str,
                    hausnummer: ''
                };
            }
        }
    }

    registerNfcReceiver(prio: number, func: (event: NfcEvent) => void): number {
        const id = ++this.nfcRecieverId;

        this.nfcReceivers.push({
            func,
            prio,
            id
        });

        // Sortiere die Liste absteigend nach Prio
        this.nfcReceivers.sort((a, b) => b.prio - a.prio);

        return id;
    }

    unregisterNfcReceiver(registrationId: number) {
        if (registrationId) {
            const idx = this.nfcReceivers.findIndex(p => p.id === registrationId);

            if (idx >= 0) {
                this.nfcReceivers.splice(idx, 1);
            }
        }
    }

    //     async starteNavigationPTV(adresse: Adresse): Promise<boolean> {
    //         log?.debug('starteNavigationPTV', adresse);

    //         const options = {
    //             action: this.webIntent.ACTION_VIEW,
    //             url: 'file:///storage/emulated/0/tour.bcr',

    //         }
    //  String address = "DE,76131,Karlsruhe,Haid,15";
    //     String uri = "geo:0,0?q=" + address;
    //         if (AppConfig.current.einstellungen.NavigationGeoKoordinatenBevorzugen === 'ja') {
    //             if (adresse.GeoX && adresse.GeoY) {
    //                 destination = adresse.GeoY + ' ' + adresse.GeoX;
    //             } else if (adresse.Strasse && adresse.PLZ && adresse.Ort) {
    //                 destination = adresse.Strasse + ', ' + adresse.PLZ + ' ' + adresse.Ort;
    //             }
    //         } else {
    //             if (adresse.Strasse && adresse.PLZ && adresse.Ort) {
    //                 destination = adresse.Strasse + ', ' + adresse.PLZ + ' ' + adresse.Ort;
    //             } else if (adresse.GeoX && adresse.GeoY) {
    //                 destination = adresse.GeoY + ' ' + adresse.GeoX;
    //             }
    //         }

    //         String fileName = "";
    //         String uri = "file://" + fileName;
    //         Intent intent = new Intent(android.content.Intent.ACTION_VIEW, Uri.parse(uri));
    //         intent.addFlags(Intent.FLAG_ACTIVITY_REORDER_TO_FRONT);
    //         intent.addFlags(Intent.FLAG_ACTIVITY_NEW_TASK);

    //         window.plugins.intentShim.startActivity(
    //             {
    //                 action: window.plugins.intentShim.ACTION_VIEW,
    //                 url: 'geo:0,0?q=London'
    //             },
    //             function() {},
    //             function() {alert('Failed to open URL via Android Intent')}
    //             );

    //         this.webIntent.startActivity(options).then(onSuccess, onError);

    //         return true;
    //     }

    reverseGeocoding(latitude: number, longitude: number): Promise<Adresse> {
        let nativegeocoder = (window as any).nativegeocoder as any;

        if (!nativegeocoder) {
            log.warn('nativegeocoder nicht verfügbar');
            return Promise.resolve(null);
        }

        let options = {};

        return new Promise(resolve => {
            nativegeocoder.reverseGeocode(
                (success) => {
                    // Success
                    log?.debug('reverseGeocode: ' + JSON.stringify(success));

                    const array = success as any[];

                    if (array?.length) {
                        let a1 = array[0];

                        const adresse: Adresse = {
                            GeocodingLatitude: a1.latitude,
                            GeocodingLongitude: a1.longitude,
                            LKZ: a1.countryCode,
                            PLZ: a1.postalCode,
                            Ort: a1.locality,
                            Strasse: a1.thoroughfare + ' ' + a1.subThoroughfare
                        }

                        resolve(adresse);
                    } else {
                        resolve(null);
                    }
                },
                (err) => {
                    // Error
                    log.warn('reverseGeocode: ' + Utils.getErrorMessage(err));
                    resolve(null);
                }, latitude, longitude, options);
        });
    }

    moveToForeground(info: string) {
        log?.debug('moveToForeground: ' + info);

        if (!MyApp.isCordovaAvailable()) {
            return;
        }

        try {
            MyApp.wakeup();
        } catch (err) {
            log.error(Utils.getErrorMessage(err));
        }
    }

    async loescheAlteDateien(pfad: string, alterInTagen: number, prefixListe: string[]) {
        log?.debug(`loescheAlteDateien: ${pfad}`);

        // Zeitstempel in Millisekunden berechnen (14 Tage in die Vergangenheit)
        const schwellenwert = Date.now() - (alterInTagen * 24 * 60 * 60 * 1000);

        try {
            const result = await Filesystem.readdir({
                path: pfad,
                directory: Directory.Data
            });

            for (const datei of result.files) {
                const vollerPfad = pfad === '' ? datei.name : `${pfad}/${datei.name}`;

                if (datei.type === 'directory') {
                    // Rekursion: In den Unterordner gehen
                    await this.loescheAlteDateien(vollerPfad, alterInTagen, prefixListe);
                } else {
                    // 1. Check: Ist die Datei älter als der Schwellenwert?
                    // Hinweis: mtime ist der Zeitstempel der letzten Änderung
                    const istAltGenug = datei.mtime && datei.mtime < schwellenwert;

                    // 2. Check: Entspricht der Dateiname einem der Prefixe?
                    const hatPrefix = prefixListe.some(prefix => datei.name.startsWith(prefix));

                    if (istAltGenug && hatPrefix) {
                        await Filesystem.deleteFile({
                            path: vollerPfad,
                            directory: Directory.Data
                        });

                        log?.debug(`Alte Datei gelöscht: ${vollerPfad} (Alt: ${new Date(datei.mtime!).toLocaleDateString()})`);
                    }
                }
            }
        } catch (error) {
            log.error(`Fehler beim Verarbeiten von ${pfad}: ` + Utils.getErrorMessage(error), error);
        }
    }
}

// interface Postausgang {
//     textdateiIds: number[];
//     lastId: number;
// }

interface NfcReceiver {
    func: (event: any) => void;
    prio: number;
    id: number;
}

